import './index.css';var Xt = Object.defineProperty;
var Zt = (i, e, t) => e in i ? Xt(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var I = (i, e, t) => Zt(i, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as P, jsx as p, Fragment as Q } from "react/jsx-runtime";
import { Button as M, Tooltip as Jt, Modal as wt, Field as ge, Input as Re, Textarea as _t, Collapse as Ge, Radio as Te, Select as qt, RadioButtonGroup as Wt, Checkbox as Qt, Scrollbar as en } from "@repo/go-ui";
import { hasValue as w, getWellStatusColor as tn, equalsDeep as nn } from "@repo/utils";
import { observer as L } from "mobx-react-lite";
import { useState as le, useMemo as Pe, useEffect as Me } from "react";
import { useTranslation as N, initReactI18next as rn, I18nextProvider as ln } from "react-i18next";
import { ExpandUpLight as Tt, ExpandDownLight as Ft, BookmarkFill as sn, BookmarkLight as on, DotsEditCustom as an, CloseMiniLine as Ct, DoneLight as xt, FilterAltLight as cn, ExportLight as dn, ArhiveAltExportLight as pn, CloseRoundLight as un, SearchLight as hn, VerticalCustom as fn, CheckRingLight as mn } from "@repo/go-icons";
import { action as y, makeObservable as Ie, reaction as Ae, observable as T, computed as _, flow as H, runInAction as Y } from "mobx";
import gn from "i18next";
function Pt(i) {
  var e, t, n = "";
  if (typeof i == "string" || typeof i == "number") n += i;
  else if (typeof i == "object") if (Array.isArray(i)) {
    var r = i.length;
    for (e = 0; e < r; e++) i[e] && (t = Pt(i[e])) && (n && (n += " "), n += t);
  } else for (t in i) i[t] && (n && (n += " "), n += t);
  return n;
}
function D() {
  for (var i, e, t = 0, n = "", r = arguments.length; t < r; t++) (i = arguments[t]) && (e = Pt(i)) && (n && (n += " "), n += e);
  return n;
}
const bn = {
  status: [],
  workStartDateFrom: null,
  workStartDateTo: null,
  organizationId: [],
  blockId: [],
  fieldId: [],
  padId: [],
  wellId: [],
  rigModelId: [],
  brigadeId: [],
  wellboreTypeInstanceId: []
}, kt = 2, K = {
  showFact: !0,
  showPlan: !0,
  showWellbores: !0,
  showTrajectories: !0
}, yn = { wells: [] };
function ae(i) {
  if (i.length === 0)
    return "unchecked";
  let e = !1, t = !1, n = !1;
  for (const r of i)
    r === "checked" ? e = !0 : r === "unchecked" ? t = !0 : n = !0;
  return n || e && t ? "intermediate" : e ? "checked" : "unchecked";
}
function In(i, e) {
  return i.wells.find((t) => t.wellId === e);
}
function Dt(i, e) {
  return i == null ? void 0 : i.find((t) => t.wellboreId === e);
}
function vn(i, e) {
  return i == null ? void 0 : i.find((t) => t.designId === e);
}
function be(i, e, t, n = !0) {
  const r = Dt(i, e);
  if (!r) return "unchecked";
  if (!n || r.trajectories.length === 0 || !t || t.length === 0)
    return "checked";
  const l = new Set(r.trajectories.map((o) => o.trajectoryId)), s = t.map((o) => l.has(o) ? "checked" : "unchecked");
  return ae(s);
}
function Sn(i, e, t) {
  const n = Dt(i, e);
  return n && (n.trajectories.length === 0 || n.trajectories.some((r) => r.trajectoryId === t)) ? "checked" : "unchecked";
}
function Le(i, e, t, n = !0, r = !0) {
  const l = vn(i, e);
  if (!l) return "unchecked";
  if (!r || l.wellbores.length === 0 || !t || t.length === 0)
    return "checked";
  const s = t.map(
    (o) => be(
      l.wellbores,
      o.id,
      o.trajectories.map((a) => a.id),
      n
    )
  );
  return ae(s);
}
function Be(i, e, t = K) {
  if (!t.showFact || !i || i.fact === void 0)
    return "unchecked";
  if (i.fact.length === 0 || !t.showWellbores)
    return "checked";
  const n = e == null ? void 0 : e.factWellbores;
  if (!n || n.length === 0)
    return "checked";
  const r = n.map(
    (l) => be(
      i.fact,
      l.id,
      l.trajectories.map((s) => s.id),
      t.showTrajectories
    )
  );
  return ae(r);
}
function Oe(i, e, t = K) {
  if (!t.showPlan || !i || i.plan === void 0)
    return "unchecked";
  if (i.plan.length === 0)
    return "checked";
  const n = e == null ? void 0 : e.planDesigns;
  if (!n || n.length === 0)
    return "checked";
  const r = n.map(
    (l) => Le(i.plan, l.id, l.wellbores, t.showTrajectories, t.showWellbores)
  );
  return ae(r);
}
function $e(i, e, t, n = K) {
  const r = In(i, e);
  if (!r) return "unchecked";
  const l = [];
  return n.showFact && l.push(Be(r, t, n)), n.showPlan && l.push(Oe(r, t, n)), l.length === 0 ? "checked" : ae(l);
}
function wn(i, e, t, n = K) {
  if (e.length === 0)
    return "unchecked";
  const r = e.map((l) => $e(i, l, t == null ? void 0 : t(l), n));
  return ae(r);
}
function B(i) {
  return i === "checked";
}
function ee(i) {
  return i === "intermediate";
}
function se(i) {
  return i !== "unchecked";
}
function ke(i) {
  return !i || !Array.isArray(i.wells) ? { wells: [] } : { wells: i.wells };
}
function G(i) {
  return structuredClone(ke(i));
}
function Fe() {
  return G(yn);
}
function J(i) {
  return i ? {
    status: [...i.status],
    workStartDateFrom: i.workStartDateFrom,
    workStartDateTo: i.workStartDateTo,
    organizationId: [...i.organizationId],
    blockId: [...i.blockId],
    fieldId: [...i.fieldId],
    padId: [...i.padId],
    wellId: [...i.wellId],
    rigModelId: [...i.rigModelId],
    brigadeId: [...i.brigadeId],
    wellboreTypeInstanceId: [...i.wellboreTypeInstanceId]
  } : null;
}
function X(i) {
  return Array.isArray(i) && i.every((e) => typeof e == "string" || typeof e == "number");
}
function _n(i) {
  if (i == null || !i || typeof i != "object")
    return null;
  const e = i, t = bn;
  return {
    status: Array.isArray(e.status) ? e.status.filter((n) => typeof n == "string") : [...t.status],
    workStartDateFrom: typeof e.workStartDateFrom == "number" ? e.workStartDateFrom : null,
    workStartDateTo: typeof e.workStartDateTo == "number" ? e.workStartDateTo : null,
    organizationId: X(e.organizationId) ? [...e.organizationId] : [...t.organizationId],
    blockId: X(e.blockId) ? [...e.blockId] : [...t.blockId],
    fieldId: X(e.fieldId) ? [...e.fieldId] : [...t.fieldId],
    padId: X(e.padId) ? [...e.padId] : [...t.padId],
    wellId: X(e.wellId) ? [...e.wellId] : [...t.wellId],
    rigModelId: X(e.rigModelId) ? [...e.rigModelId] : [...t.rigModelId],
    brigadeId: X(e.brigadeId) ? [...e.brigadeId] : [...t.brigadeId],
    wellboreTypeInstanceId: X(e.wellboreTypeInstanceId) ? [...e.wellboreTypeInstanceId] : [...t.wellboreTypeInstanceId]
  };
}
function he(i) {
  return i ? i.status.length === 0 && i.workStartDateFrom === null && i.workStartDateTo === null && i.organizationId.length === 0 && i.blockId.length === 0 && i.fieldId.length === 0 && i.padId.length === 0 && i.wellId.length === 0 && i.rigModelId.length === 0 && i.brigadeId.length === 0 && i.wellboreTypeInstanceId.length === 0 : !0;
}
function Et(i, e = null) {
  return {
    schemaVersion: kt,
    tree: G(i),
    filters: J(e)
  };
}
function Wn(i, e, t = K) {
  const n = ke(i), r = [];
  for (const l of n.wells) {
    const s = Cn(l, e(l.wellId));
    s && r.push(s);
  }
  return { wells: r };
}
function Gt(i, e, t, n = K) {
  return Et(
    Wn(i, t, n),
    e
  );
}
function fe(i) {
  var t;
  if (!i || typeof i != "object")
    return {
      tree: Fe(),
      filters: null
    };
  const e = i;
  return e.schemaVersion === 1 ? {
    tree: G(e.tree),
    filters: null
  } : e.schemaVersion === kt ? {
    tree: G(e.tree),
    filters: _n((t = e.filters) != null ? t : null)
  } : {
    tree: Fe(),
    filters: null
  };
}
function Sl(i) {
  return fe(i).tree;
}
function At(i, e, t) {
  return e ? {
    wellboreId: i.wellboreId,
    trajectories: i.trajectories.map((n) => ({ trajectoryId: n.trajectoryId }))
  } : B(
    be([i], i.wellboreId, t, !0)
  ) ? { wellboreId: i.wellboreId, trajectories: [] } : null;
}
function Tn(i, e, t) {
  var r;
  if (i.wellbores.length === 0)
    return { designId: i.designId, wellbores: [] };
  const n = [];
  for (const l of i.wellbores) {
    const s = (r = t == null ? void 0 : t.find((a) => a.id === l.wellboreId)) == null ? void 0 : r.trajectories.map((a) => a.id), o = At(l, e, s);
    o && n.push(o);
  }
  return n.length === 0 ? B(Le([i], i.designId, t, !0)) ? { designId: i.designId, wellbores: [] } : null : { designId: i.designId, wellbores: n };
}
function Fn(i, e, t) {
  var r, l;
  const n = { wellId: i.wellId };
  if (t.showFact && i.fact !== void 0)
    if (i.fact.length === 0)
      n.fact = [];
    else {
      const s = [];
      for (const o of i.fact) {
        const a = (r = e == null ? void 0 : e.factWellbores.find((u) => u.id === o.wellboreId)) == null ? void 0 : r.trajectories.map((u) => u.id), c = At(o, t.showTrajectories, a);
        c && s.push(c);
      }
      s.length > 0 && (n.fact = s);
    }
  if (t.showPlan && i.plan !== void 0)
    if (i.plan.length === 0)
      n.plan = [];
    else {
      const s = [];
      for (const o of i.plan) {
        const a = (l = e == null ? void 0 : e.planDesigns.find((u) => u.id === o.designId)) == null ? void 0 : l.wellbores, c = Tn(o, t.showTrajectories, a);
        c && s.push(c);
      }
      s.length > 0 && (n.plan = s);
    }
  return n.fact === void 0 && n.plan === void 0 ? !t.showFact && !t.showPlan ? n : null : n;
}
function jt(i, e, t = K) {
  const n = ke(i), r = [];
  for (const l of n.wells) {
    const s = Fn(l, e(l.wellId), t);
    s && r.push(s);
  }
  return { wells: r };
}
function me(i, e) {
  return i.trajectories.length > 0 ? {
    wellboreId: i.wellboreId,
    trajectories: i.trajectories.map((t) => ({ trajectoryId: t.trajectoryId }))
  } : {
    wellboreId: i.wellboreId,
    trajectories: e.map((t) => ({ trajectoryId: t }))
  };
}
function Nt(i, e) {
  var n;
  const t = (n = e == null ? void 0 : e.factWellbores) != null ? n : [];
  return i.length === 0 ? t.map(
    (r) => me(
      { wellboreId: r.id, trajectories: [] },
      r.trajectories.map((l) => l.id)
    )
  ) : i.map((r) => {
    var s, o;
    const l = (o = (s = t.find((a) => a.id === r.wellboreId)) == null ? void 0 : s.trajectories.map((a) => a.id)) != null ? o : [];
    return me(r, l);
  });
}
function Rt(i, e) {
  var n;
  const t = (n = e == null ? void 0 : e.planDesigns) != null ? n : [];
  return i.length === 0 ? t.map((r) => ({
    designId: r.id,
    wellbores: r.wellbores.map(
      (l) => me(
        { wellboreId: l.id, trajectories: [] },
        l.trajectories.map((s) => s.id)
      )
    )
  })) : i.map((r) => {
    var o;
    const l = t.find((a) => a.id === r.designId), s = (o = l == null ? void 0 : l.wellbores) != null ? o : [];
    return r.wellbores.length === 0 ? {
      designId: r.designId,
      wellbores: s.map(
        (a) => me(
          { wellboreId: a.id, trajectories: [] },
          a.trajectories.map((c) => c.id)
        )
      )
    } : {
      designId: r.designId,
      wellbores: r.wellbores.map((a) => {
        var u, d;
        const c = (d = (u = s.find((h) => h.id === a.wellboreId)) == null ? void 0 : u.trajectories.map((h) => h.id)) != null ? d : [];
        return me(a, c);
      })
    };
  });
}
function Cn(i, e) {
  const t = { wellId: i.wellId };
  return i.fact !== void 0 && (t.fact = Nt(i.fact, e)), i.plan !== void 0 && (t.plan = Rt(i.plan, e)), t.fact === void 0 && t.plan === void 0 ? null : t;
}
function xn(i, e, t = K) {
  const n = ke(i), r = [];
  for (const l of n.wells) {
    const s = e(l.wellId), o = { wellId: l.wellId };
    t.showFact && l.fact !== void 0 && (o.fact = Nt(l.fact, s)), t.showPlan && l.plan !== void 0 && (o.plan = Rt(l.plan, s)), !(o.fact === void 0 && o.plan === void 0) && r.push(o);
  }
  return { wells: r };
}
const Pn = "applied-filters-section-module__root__OTZuV", kn = "applied-filters-section-module__header__V9LXK", Dn = "applied-filters-section-module__expandIcon__cvZnP", En = "applied-filters-section-module__title__opcif", Gn = "applied-filters-section-module__chips__oocac", An = "applied-filters-section-module__chip__pkpuw", te = {
  root: Pn,
  header: kn,
  expandIcon: Dn,
  title: En,
  chips: Gn,
  chip: An
};
function jn(i) {
  const e = typeof i == "number" ? i : Number(i);
  return Number.isFinite(e) ? e : null;
}
function Xe(i) {
  try {
    return new Date(i * 1e3).toLocaleDateString();
  } catch {
    return String(i);
  }
}
function Nn(i, e) {
  var n, r, l, s, o, a, c, u, d, h, m, f, S, W;
  const t = {
    organizationId: /* @__PURE__ */ new Map(),
    blockId: /* @__PURE__ */ new Map(),
    fieldId: /* @__PURE__ */ new Map(),
    padId: /* @__PURE__ */ new Map(),
    wellId: /* @__PURE__ */ new Map(),
    rigModelId: /* @__PURE__ */ new Map(),
    brigadeId: /* @__PURE__ */ new Map(),
    wellboreTypeInstanceId: /* @__PURE__ */ new Map()
  };
  for (const v of i) {
    t.wellId.set(v.id, v.name), ((n = v.organization) == null ? void 0 : n.id) != null && v.organization.name && t.organizationId.set(v.organization.id, v.organization.name), ((r = v.block) == null ? void 0 : r.organizationId) != null && ((l = v.organization) != null && l.name) && t.organizationId.set(v.block.organizationId, v.organization.name), ((s = v.block) == null ? void 0 : s.id) != null && v.block.name && t.blockId.set(v.block.id, v.block.name), ((o = v.field) == null ? void 0 : o.id) != null && v.field.name && t.fieldId.set(v.field.id, v.field.name);
    const R = (c = v.padId) != null ? c : (a = v.pad) == null ? void 0 : a.id, O = (h = (u = v.pad) == null ? void 0 : u.abbreviatedName) != null ? h : (d = v.pad) == null ? void 0 : d.name;
    R != null && O && t.padId.set(R, O), ((m = v.rigModel) == null ? void 0 : m.id) != null && v.rigModel.name && t.rigModelId.set(v.rigModel.id, v.rigModel.name);
    const ie = (S = v.brigadeId) != null ? S : (f = v.brigade) == null ? void 0 : f.id, E = (W = v.brigade) == null ? void 0 : W.name;
    ie != null && E && t.brigadeId.set(ie, E);
    const ce = e(v.id);
    if (ce) {
      for (const re of ce.factWellbores)
        re.typeInstanceId != null && re.typeInstanceName && t.wellboreTypeInstanceId.set(re.typeInstanceId, re.typeInstanceName);
      for (const re of ce.planDesigns)
        for (const ve of re.wellbores)
          ve.typeInstanceId != null && ve.typeInstanceName && t.wellboreTypeInstanceId.set(ve.typeInstanceId, ve.typeInstanceName);
    }
  }
  return t;
}
function Rn(i, e) {
  var n;
  const t = jn(i);
  return t == null ? String(i) : (n = e.get(t)) != null ? n : String(i);
}
function Mn(i, e, t) {
  if (!i || he(i))
    return [];
  const n = [];
  for (const l of i.status) {
    const s = l.toString().toUpperCase(), o = s === "ACTIVE" || s === "ACTIVE_GREEN" || s === "ACTIVE_YELLOW" || s === "ACTIVE_RED" ? t("Filters.statusActive") : s === "COMPLETED" ? t("Filters.statusCompleted") : String(l);
    n.push({ id: `status:${l}`, label: o });
  }
  i.workStartDateFrom !== null && n.push({ id: "workStartDateFrom", label: Xe(i.workStartDateFrom) }), i.workStartDateTo !== null && n.push({ id: "workStartDateTo", label: Xe(i.workStartDateTo) });
  const r = [
    "organizationId",
    "blockId",
    "fieldId",
    "padId",
    "wellId",
    "rigModelId",
    "brigadeId",
    "wellboreTypeInstanceId"
  ];
  for (const l of r)
    for (const s of i[l])
      n.push({
        id: `${l}:${s}`,
        label: Rn(s, e[l])
      });
  return n;
}
const Ln = L(function({ store: e }) {
  const { t } = N(), [n, r] = le(!0), l = Nn(e.wellsSourceAllWells, (o) => e.getWellChildren(o)), s = Mn(e.filters, l, t);
  return s.length === 0 ? null : /* @__PURE__ */ P("section", { className: te.root, children: [
    /* @__PURE__ */ P(
      "button",
      {
        type: "button",
        className: te.header,
        "aria-expanded": n,
        onClick: () => r((o) => !o),
        children: [
          n ? /* @__PURE__ */ p(Tt, { className: te.expandIcon }) : /* @__PURE__ */ p(Ft, { className: te.expandIcon }),
          /* @__PURE__ */ p("span", { className: D("dash-body-bold", te.title), children: t("Filters.title") })
        ]
      }
    ),
    n && /* @__PURE__ */ p("div", { className: te.chips, children: s.map((o) => /* @__PURE__ */ p("span", { className: D("dash-body-medium", te.chip), children: o.label }, o.id)) })
  ] });
}), Bn = "group-action-list-module__list__KVSHC", On = "group-action-list-module__listItem__2jJ3J", $n = "group-action-list-module__listItemRegular__dQCDt", Vn = "group-action-list-module__listItemDangerous__hbMiN", zn = "group-action-list-module__listItemDisabled__LOW51", de = {
  list: Bn,
  listItem: On,
  listItemRegular: $n,
  listItemDangerous: Vn,
  listItemDisabled: zn
};
function Hn({ actions: i }) {
  return /* @__PURE__ */ p("div", { className: D("dash-body-regular", de.list), children: i.map(
    (e) => e && /* @__PURE__ */ p(
      "div",
      {
        className: D(
          de.listItem,
          e.variant === "dangerous" ? de.listItemDangerous : de.listItemRegular,
          e.disabled && de.listItemDisabled
        ),
        onClick: e.disabled ? void 0 : e.onClick,
        children: e.title
      },
      e.id
    )
  ) });
}
const Un = "group-item-module__item__n8jHb", Kn = "group-item-module__itemActive__WbuDd", Yn = "group-item-module__name__iY5-P", Xn = "group-item-module__menuButton__waoDQ", Zn = "group-item-module__favoriteButton__uN6-t", Jn = "group-item-module__favoriteIcon__xA3r3", qn = "group-item-module__favoriteIconActive__mTBWP", Qn = "group-item-module__menuIcon__2Wqf1", Z = {
  item: Un,
  itemActive: Kn,
  name: Yn,
  menuButton: Xn,
  favoriteButton: Zn,
  favoriteIcon: Jn,
  favoriteIconActive: qn,
  menuIcon: Qn
}, Ze = L(function({ group: e, templatesStore: t, isActive: n = !1 }) {
  const { t: r } = N(), [l, s] = le(!1), o = e.visibility === "personal", a = Pe(
    () => [
      {
        id: 0,
        title: r("GroupActions.apply"),
        onClick: () => {
          t.applyGroup(e.id, e.visibility), s(!1);
        }
      },
      {
        id: 1,
        title: r("GroupActions.rename"),
        onClick: () => {
          t.openRenameModal(e), s(!1);
        }
      },
      {
        id: 2,
        title: r(o ? "GroupActions.copyToPublic" : "GroupActions.copyToPersonal"),
        onClick: () => {
          t.duplicateGroup(e.id, e.visibility), s(!1);
        }
      },
      {
        id: 3,
        title: r("GroupActions.delete"),
        variant: "dangerous",
        onClick: () => {
          t.deleteGroup(e.id, e.visibility), s(!1);
        }
      }
    ],
    [e, o, r, t]
  ), c = (u) => {
    u.stopPropagation(), t.toggleGroupFavorite(e.id);
  };
  return /* @__PURE__ */ P("div", { className: D(Z.item, n && Z.itemActive), children: [
    /* @__PURE__ */ p(
      M,
      {
        type: "button",
        variant: "flat",
        size: "s",
        className: D("dash-body-regular", Z.name),
        title: e.name,
        onClick: () => t.applyGroup(e.id, e.visibility),
        children: e.name
      }
    ),
    /* @__PURE__ */ p(
      M,
      {
        type: "button",
        variant: "flat",
        size: "s",
        className: Z.favoriteButton,
        title: r(e.isFavorite ? "GroupActions.removeFavorite" : "GroupActions.addFavorite"),
        icon: e.isFavorite ? /* @__PURE__ */ p(sn, { className: Z.favoriteIconActive }) : /* @__PURE__ */ p(on, { className: Z.favoriteIcon }),
        onClick: c
      }
    ),
    /* @__PURE__ */ p(
      Jt,
      {
        placement: "bottom-end",
        title: /* @__PURE__ */ p(Hn, { actions: a }),
        trigger: ["click"],
        open: l,
        onOpenChange: s,
        style: { paddingLeft: 0, paddingRight: 0 },
        withArrow: !1,
        children: /* @__PURE__ */ p(
          M,
          {
            type: "button",
            variant: "flat",
            size: "s",
            className: Z.menuButton,
            title: r("GroupActions.menu"),
            icon: /* @__PURE__ */ p(an, { className: Z.menuIcon })
          }
        )
      }
    )
  ] });
}), ei = "groups-tab-module__root__Jw7bf", ti = "groups-tab-module__list__1fwo2", ni = "groups-tab-module__empty__0jeFG", pe = {
  root: ei,
  list: ti,
  empty: ni
}, wl = "GOdashboard_ReferenceDataTemplates", Mt = 40, Lt = 500, ii = "group-form-modal-module__body__-cyp0", ri = "group-form-modal-module__modeRadios__Yr1-Z", li = "group-form-modal-module__radioRow__BXDbL", si = "group-form-modal-module__actions__wAccO", ne = {
  body: ii,
  modeRadios: ri,
  radioRow: li,
  actions: si
}, oi = L(function({ templatesStore: e }) {
  const { t } = N(), n = e.renameTarget, [r, l] = le(""), [s, o] = le("");
  Me(() => {
    var c, u;
    l((c = n == null ? void 0 : n.name) != null ? c : ""), o((u = n == null ? void 0 : n.description) != null ? u : "");
  }, [n]);
  const a = r.trim().length > 0 && !e.isSaving;
  return /* @__PURE__ */ p(
    wt,
    {
      open: w(n),
      title: t("RenameModal.title"),
      onClose: e.closeRenameModal,
      style: { width: 440 },
      children: /* @__PURE__ */ P("div", { className: ne.body, children: [
        /* @__PURE__ */ p(ge, { label: t("GroupForm.name"), children: /* @__PURE__ */ p(
          Re,
          {
            value: r,
            maxLength: Mt,
            disabled: e.isSaving,
            placeholder: t("GroupForm.namePlaceholder"),
            onChange: (c) => l(c.target.value)
          }
        ) }),
        /* @__PURE__ */ p(ge, { label: t("GroupForm.description"), children: /* @__PURE__ */ p(
          _t,
          {
            value: s,
            maxLength: Lt,
            minRows: 1,
            maxRows: 5,
            disabled: e.isSaving,
            placeholder: t("GroupForm.descriptionPlaceholder"),
            style: { width: "100%", maxWidth: "100%" },
            onChange: o
          }
        ) }),
        /* @__PURE__ */ P("div", { className: ne.actions, children: [
          /* @__PURE__ */ p(
            M,
            {
              variant: "danger",
              icon: /* @__PURE__ */ p(Ct, {}),
              disabled: e.isSaving,
              onClick: e.closeRenameModal,
              children: t("GroupForm.cancel")
            }
          ),
          /* @__PURE__ */ p(
            M,
            {
              variant: "success",
              icon: /* @__PURE__ */ p(xt, {}),
              loading: e.isSaving,
              disabled: !a || !w(n),
              onClick: () => {
                w(n) && e.renameGroup(n.id, n.visibility, r, s);
              },
              children: t("GroupForm.save")
            }
          )
        ] })
      ] })
    }
  );
}), Je = {
  "--go-collapse-body-padding-right": 0,
  "--go-collapse-body-padding-left": 0,
  "--go-collapse-body-padding-top": "4px",
  "--go-collapse-body-padding-bottom": "8px"
}, ai = L(function({ templatesStore: e }) {
  const { t } = N(), { publicGroups: n, personalGroups: r, lastAppliedTemplateId: l, isLoading: s } = e;
  return /* @__PURE__ */ P("div", { className: pe.root, children: [
    /* @__PURE__ */ p("div", { className: pe.list, children: s ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", pe.empty), children: t("Groups.loading") }) : /* @__PURE__ */ P(Ge, { defaultValue: ["Public", "Personal"], children: [
      /* @__PURE__ */ p(
        Ge.Panel,
        {
          header: t("Groups.public"),
          panelKey: "Public",
          styleWrapper: Je,
          stickyHeader: !0,
          children: n.length === 0 ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", pe.empty), children: t("Groups.empty") }) : n.map((o) => /* @__PURE__ */ p(
            Ze,
            {
              group: o,
              templatesStore: e,
              isActive: l === o.id
            },
            o.id
          ))
        },
        "Public"
      ),
      /* @__PURE__ */ p(
        Ge.Panel,
        {
          header: t("Groups.personal"),
          panelKey: "Personal",
          styleWrapper: Je,
          stickyHeader: !0,
          children: r.length === 0 ? /* @__PURE__ */ p("p", { className: D("dash-body-regular", pe.empty), children: t("Groups.empty") }) : r.map((o) => /* @__PURE__ */ p(
            Ze,
            {
              group: o,
              templatesStore: e,
              isActive: l === o.id
            },
            o.id
          ))
        },
        "Personal"
      )
    ] }) }),
    /* @__PURE__ */ p(oi, { templatesStore: e })
  ] });
}), ci = "panel-footer-module__footer__BwXU9", di = "panel-footer-module__selectionActions__ehWmp", pi = "panel-footer-module__selectionButton__PXkJS", ui = "panel-footer-module__saveButton__ZYZR2", hi = "panel-footer-module__icon__O8bIw", $ = {
  footer: ci,
  selectionActions: di,
  selectionButton: pi,
  saveButton: ui,
  icon: hi
}, fi = L(function({ store: e }) {
  var n;
  const { t } = N();
  return /* @__PURE__ */ P(Q, { children: [
    /* @__PURE__ */ P("div", { className: ne.radioRow, children: [
      /* @__PURE__ */ p(
        Te,
        {
          id: "ref-save-existing-personal",
          name: "ref-save-existing-visibility-personal",
          value: "personal",
          checked: e.existingVisibility === "personal",
          disabled: e.isSaving || e.personalDisabled,
          onChange: () => e.setExistingVisibility("personal"),
          children: t("SaveModal.personal")
        }
      ),
      /* @__PURE__ */ p(
        Te,
        {
          id: "ref-save-existing-public",
          name: "ref-save-existing-visibility-public",
          value: "public",
          checked: e.existingVisibility === "public",
          disabled: e.isSaving || e.publicDisabled,
          onChange: () => e.setExistingVisibility("public"),
          children: t("SaveModal.public")
        }
      )
    ] }),
    /* @__PURE__ */ p(ge, { label: t("SaveModal.group"), children: /* @__PURE__ */ p(
      qt,
      {
        value: (n = e.selectedGroupId) != null ? n : void 0,
        disabled: e.isExistingSelectDisabled,
        placeholder: t("SaveModal.groupPlaceholder"),
        options: e.existingOptions,
        onChange: e.onSelectedGroupChange
      }
    ) })
  ] });
}), mi = L(function({ store: e }) {
  const { t } = N();
  return /* @__PURE__ */ P(Q, { children: [
    /* @__PURE__ */ P("div", { className: ne.radioRow, children: [
      /* @__PURE__ */ p(
        Te,
        {
          id: "ref-save-new-personal",
          name: "ref-save-new-visibility-personal",
          value: "personal",
          checked: e.newVisibility === "personal",
          disabled: e.isSaving,
          onChange: () => e.setNewVisibility("personal"),
          children: t("SaveModal.personal")
        }
      ),
      /* @__PURE__ */ p(
        Te,
        {
          id: "ref-save-new-public",
          name: "ref-save-new-visibility-public",
          value: "public",
          checked: e.newVisibility === "public",
          disabled: e.isSaving,
          onChange: () => e.setNewVisibility("public"),
          children: t("SaveModal.public")
        }
      )
    ] }),
    /* @__PURE__ */ p(ge, { label: t("GroupForm.name"), children: /* @__PURE__ */ p(
      Re,
      {
        value: e.name,
        maxLength: e.maxNameLength,
        disabled: e.isSaving,
        placeholder: t("GroupForm.namePlaceholder"),
        onChange: e.onNameInputChange
      }
    ) }),
    /* @__PURE__ */ p(ge, { label: t("GroupForm.description"), children: /* @__PURE__ */ p(
      _t,
      {
        value: e.description,
        maxLength: e.maxDescriptionLength,
        minRows: 1,
        maxRows: 5,
        disabled: e.isSaving,
        placeholder: t("GroupForm.descriptionPlaceholder"),
        style: { width: "100%", maxWidth: "100%" },
        onChange: e.onDescriptionChange
      }
    ) })
  ] });
});
var gi = Object.defineProperty, bi = Object.getOwnPropertyDescriptor, k = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? bi(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && gi(e, t, r), r;
};
class F {
  constructor(e) {
    I(this, "templatesStore");
    I(this, "disposers", []);
    I(this, "maxNameLength", Mt);
    I(this, "maxDescriptionLength", Lt);
    I(this, "mode", "new");
    I(this, "name", "");
    I(this, "description", "");
    I(this, "newVisibility", "personal");
    I(this, "existingVisibility", "personal");
    I(this, "selectedGroupId", null);
    this.templatesStore = e, Ie(this), this.disposers.push(
      Ae(
        () => this.templatesStore.saveModalOpen,
        (t) => {
          t && this.reset();
        }
      ),
      Ae(
        () => ({
          open: this.templatesStore.saveModalOpen,
          mode: this.mode,
          personalCount: this.templatesStore.personalGroups.length,
          publicCount: this.templatesStore.publicGroups.length,
          existingVisibility: this.existingVisibility
        }),
        () => this.syncExistingVisibility()
      ),
      Ae(
        () => ({
          open: this.templatesStore.saveModalOpen,
          mode: this.mode,
          optionIds: this.existingOptions.map((t) => t.value).join(","),
          selectedGroupId: this.selectedGroupId
        }),
        () => this.syncSelectedGroupId()
      )
    );
  }
  dispose() {
    for (const e of this.disposers)
      e();
    this.disposers.length = 0;
  }
  get isOpen() {
    return this.templatesStore.saveModalOpen;
  }
  get isSaving() {
    return this.templatesStore.isSaving;
  }
  get hasAnyGroups() {
    return this.templatesStore.hasAnyGroups;
  }
  get effectiveMode() {
    return this.hasAnyGroups ? this.mode : "new";
  }
  get isNewMode() {
    return this.effectiveMode === "new";
  }
  get personalDisabled() {
    return this.templatesStore.personalGroups.length === 0;
  }
  get publicDisabled() {
    return this.templatesStore.publicGroups.length === 0;
  }
  get existingOptions() {
    return (this.existingVisibility === "personal" ? this.templatesStore.personalGroups : this.templatesStore.publicGroups).map((t) => ({ value: t.id, label: t.name }));
  }
  get isExistingSelectDisabled() {
    return this.isSaving || this.existingOptions.length === 0;
  }
  get canSubmit() {
    return this.isSaving ? !1 : this.isNewMode ? this.name.trim().length > 0 : w(this.selectedGroupId);
  }
  setMode(e) {
    this.mode = e;
  }
  setNewVisibility(e) {
    this.newVisibility = e;
  }
  setExistingVisibility(e) {
    this.existingVisibility = e;
  }
  onNameInputChange(e) {
    this.name = e.target.value;
  }
  onDescriptionChange(e) {
    this.description = e;
  }
  onSelectedGroupChange(e) {
    this.selectedGroupId = typeof e == "string" ? e : null;
  }
  close() {
    this.templatesStore.closeSaveModal();
  }
  submit() {
    if (this.canSubmit) {
      if (this.isNewMode) {
        this.templatesStore.createGroupFromCurrentSelection(this.name, this.newVisibility, this.description);
        return;
      }
      w(this.selectedGroupId) && this.templatesStore.updateGroupWithCurrentTree(this.selectedGroupId, this.existingVisibility);
    }
  }
  reset() {
    this.mode = "new", this.name = "", this.description = "", this.newVisibility = "personal", this.selectedGroupId = null, this.templatesStore.personalGroups.length > 0 ? this.existingVisibility = "personal" : this.templatesStore.publicGroups.length > 0 ? this.existingVisibility = "public" : this.existingVisibility = "personal";
  }
  syncExistingVisibility() {
    if (!this.templatesStore.saveModalOpen || this.mode !== "existing")
      return;
    const { personalGroups: e, publicGroups: t } = this.templatesStore;
    this.existingVisibility === "personal" && e.length === 0 && t.length > 0 && (this.existingVisibility = "public"), this.existingVisibility === "public" && t.length === 0 && e.length > 0 && (this.existingVisibility = "personal");
  }
  syncSelectedGroupId() {
    var e, t;
    !this.templatesStore.saveModalOpen || this.mode !== "existing" || (!this.selectedGroupId || !this.existingOptions.some((n) => n.value === this.selectedGroupId)) && (this.selectedGroupId = (t = (e = this.existingOptions[0]) == null ? void 0 : e.value) != null ? t : null);
  }
}
k([
  T
], F.prototype, "mode", 2);
k([
  T
], F.prototype, "name", 2);
k([
  T
], F.prototype, "description", 2);
k([
  T
], F.prototype, "newVisibility", 2);
k([
  T
], F.prototype, "existingVisibility", 2);
k([
  T
], F.prototype, "selectedGroupId", 2);
k([
  _
], F.prototype, "isOpen", 1);
k([
  _
], F.prototype, "isSaving", 1);
k([
  _
], F.prototype, "hasAnyGroups", 1);
k([
  _
], F.prototype, "effectiveMode", 1);
k([
  _
], F.prototype, "isNewMode", 1);
k([
  _
], F.prototype, "personalDisabled", 1);
k([
  _
], F.prototype, "publicDisabled", 1);
k([
  _
], F.prototype, "existingOptions", 1);
k([
  _
], F.prototype, "isExistingSelectDisabled", 1);
k([
  _
], F.prototype, "canSubmit", 1);
k([
  y.bound
], F.prototype, "setMode", 1);
k([
  y.bound
], F.prototype, "setNewVisibility", 1);
k([
  y.bound
], F.prototype, "setExistingVisibility", 1);
k([
  y.bound
], F.prototype, "onNameInputChange", 1);
k([
  y.bound
], F.prototype, "onDescriptionChange", 1);
k([
  y.bound
], F.prototype, "onSelectedGroupChange", 1);
k([
  y.bound
], F.prototype, "close", 1);
k([
  y.bound
], F.prototype, "submit", 1);
k([
  y
], F.prototype, "reset", 1);
k([
  y
], F.prototype, "syncExistingVisibility", 1);
k([
  y
], F.prototype, "syncSelectedGroupId", 1);
const yi = L(function({ templatesStore: e }) {
  const { t } = N(), [n] = le(() => new F(e));
  Me(() => () => n.dispose(), [n]);
  const r = Pe(
    () => [
      { value: "new", label: t("SaveModal.modeNew") },
      { value: "existing", label: t("SaveModal.modeExisting") }
    ],
    [t]
  );
  return /* @__PURE__ */ p(wt, { open: n.isOpen, title: t("SaveModal.title"), onClose: n.close, style: { width: 440 }, children: /* @__PURE__ */ P("div", { className: ne.body, children: [
    n.hasAnyGroups && /* @__PURE__ */ p(
      Wt,
      {
        size: "s",
        value: n.mode,
        items: r,
        onChange: n.setMode,
        className: ne.modeRadios
      }
    ),
    n.isNewMode ? /* @__PURE__ */ p(mi, { store: n }) : /* @__PURE__ */ p(fi, { store: n }),
    /* @__PURE__ */ P("div", { className: ne.actions, children: [
      /* @__PURE__ */ p(M, { variant: "danger", icon: /* @__PURE__ */ p(Ct, {}), disabled: n.isSaving, onClick: n.close, children: t("GroupForm.cancel") }),
      /* @__PURE__ */ p(
        M,
        {
          variant: "success",
          icon: /* @__PURE__ */ p(xt, {}),
          loading: n.isSaving,
          disabled: !n.canSubmit,
          onClick: n.submit,
          children: t("GroupForm.save")
        }
      )
    ] })
  ] }) });
}), Ii = L(function({ store: e, templatesStore: t }) {
  const { t: n } = N(), r = e.hasPendingSelectionChanges, l = !e.hasFiltersHost;
  return /* @__PURE__ */ P(Q, { children: [
    /* @__PURE__ */ P("footer", { className: $.footer, children: [
      r && /* @__PURE__ */ P("div", { className: $.selectionActions, children: [
        /* @__PURE__ */ p(
          M,
          {
            variant: "primary",
            size: "m",
            className: D($.selectionButton, "dash-body-medium"),
            onClick: e.applyDraftSelection,
            children: n("Footer.apply")
          }
        ),
        /* @__PURE__ */ p(
          M,
          {
            variant: "secondary",
            size: "m",
            className: D($.selectionButton, "dash-body-medium"),
            onClick: e.resetDraftSelection,
            children: n("Footer.cancel")
          }
        )
      ] }),
      /* @__PURE__ */ P("div", { className: $.selectionActions, children: [
        /* @__PURE__ */ p(
          M,
          {
            variant: "secondary",
            size: "m",
            className: D($.selectionButton, "dash-body-medium"),
            icon: /* @__PURE__ */ p(cn, { className: $.icon }),
            disabled: l,
            onClick: e.importFiltersFromHost,
            children: n("Footer.filter")
          }
        ),
        /* @__PURE__ */ p(
          M,
          {
            variant: "secondary",
            size: "m",
            className: D($.selectionButton, "dash-body-medium"),
            icon: /* @__PURE__ */ p(dn, { className: $.icon }),
            disabled: l,
            onClick: e.exportFiltersToHost,
            children: n("Footer.exportFilters")
          }
        )
      ] }),
      /* @__PURE__ */ p(
        M,
        {
          variant: "success",
          size: "m",
          className: D($.saveButton, "dash-body-medium"),
          icon: /* @__PURE__ */ p(pn, { className: $.icon }),
          disabled: !t.canCreate || t.isSaving,
          loading: t.isSaving && t.saveModalOpen,
          onClick: t.openSaveModal,
          children: n("Footer.save")
        }
      )
    ] }),
    /* @__PURE__ */ p(yi, { templatesStore: t })
  ] });
}), vi = "panel-header-module__header__4FeMz", Si = "panel-header-module__title__jygu3", wi = "panel-header-module__closeButton__kGfqu", _i = "panel-header-module__closeIcon__5sTbF", Se = {
  header: vi,
  title: Si,
  closeButton: wi,
  closeIcon: _i
};
function Wi({ title: i, onClose: e }) {
  const { t } = N();
  return /* @__PURE__ */ P("header", { className: Se.header, children: [
    /* @__PURE__ */ p("span", { className: D("h3", Se.title), children: i }),
    w(e) && /* @__PURE__ */ p(
      M,
      {
        variant: "flat",
        className: Se.closeButton,
        icon: /* @__PURE__ */ p(un, { className: Se.closeIcon }),
        title: t("Header.close"),
        onClick: e
      }
    )
  ] });
}
const Ti = "search-bar-module__root__uqd6I", Fi = "search-bar-module__icon__85Cf9", Ci = "search-bar-module__input__GfsSf", je = {
  root: Ti,
  icon: Fi,
  input: Ci
}, xi = L(function({ store: e }) {
  const { t } = N();
  return /* @__PURE__ */ p("div", { className: je.root, children: /* @__PURE__ */ p(
    Re,
    {
      allowClear: !0,
      prefix: /* @__PURE__ */ p(hn, { className: je.icon }),
      value: e.searchValue,
      inputClassName: je.input,
      placeholder: t("Panel.searchPlaceholder"),
      onChange: (n) => e.setSearchValue(n.target.value)
    }
  ) });
}), Pi = "tree-node-module__row__0068d", ki = "tree-node-module__checkbox__T-lzz", Di = "tree-node-module__expandHitArea__tB7cl", Ei = "tree-node-module__labelGroup__56zEE", Gi = "tree-node-module__expandButton__697Gr", Ai = "tree-node-module__expandIcon__z6nrC", ji = "tree-node-module__statusIcon__Uf2oI", Ni = "tree-node-module__labelWithTrailing__9OEcT", Ri = "tree-node-module__label__ExS4n", Mi = "tree-node-module__children__kV9sb", z = {
  row: Pi,
  checkbox: ki,
  expandHitArea: Di,
  labelGroup: Ei,
  expandButton: Gi,
  expandIcon: Ai,
  statusIcon: ji,
  labelWithTrailing: Ni,
  label: Ri,
  children: Mi
};
function U({
  label: i,
  checked: e = !1,
  intermediate: t = !1,
  expanded: n,
  bold: r = !1,
  disabled: l = !1,
  expandable: s = !1,
  icon: o,
  trailing: a,
  children: c,
  onCheckedChange: u,
  onExpandToggle: d
}) {
  const { t: h } = N(), m = s, f = D(r ? "dash-body-bold" : "dash-body-regular", z.label), S = n ? /* @__PURE__ */ p(Tt, { className: z.expandIcon }) : /* @__PURE__ */ p(Ft, { className: z.expandIcon }), W = /* @__PURE__ */ P(Q, { children: [
    m && /* @__PURE__ */ p("span", { className: z.expandButton, children: S }),
    o,
    /* @__PURE__ */ P("span", { className: z.labelWithTrailing, children: [
      /* @__PURE__ */ p("span", { className: f, children: i }),
      a
    ] })
  ] });
  return /* @__PURE__ */ P(Q, { children: [
    /* @__PURE__ */ P("div", { className: z.row, children: [
      /* @__PURE__ */ p(
        Qt,
        {
          checked: e,
          intermediate: t,
          size: "s",
          disabled: l,
          className: z.checkbox,
          onChange: u
        }
      ),
      m ? /* @__PURE__ */ p(
        "button",
        {
          type: "button",
          className: z.expandHitArea,
          title: h(n ? "Tree.collapse" : "Tree.expand"),
          onClick: d,
          children: W
        }
      ) : /* @__PURE__ */ p("div", { className: z.labelGroup, children: W })
    ] }),
    s && n && /* @__PURE__ */ p("div", { className: z.children, children: c })
  ] });
}
function qe({ status: i }) {
  return /* @__PURE__ */ p(fn, { className: z.statusIcon, style: { color: tn(i) } });
}
function Li(i) {
  return i ? {
    wellId: i.wellId,
    branch: i.branch,
    designId: i.designId,
    wellboreId: i.wellboreId,
    trajectoryId: i.trajectoryId
  } : null;
}
function Bt(i, e) {
  return !i && !e ? !0 : !i || !e ? !1 : i.wellId === e.wellId && i.branch === e.branch && i.designId === e.designId && i.wellboreId === e.wellboreId && i.trajectoryId === e.trajectoryId;
}
function ye(i, e, t, n, r) {
  return !i || i.wellId !== e || i.branch !== t || i.wellboreId !== n ? !1 : t === "plan" ? i.designId === r : !0;
}
function Ve(i, e, t, n, r, l) {
  return w(i == null ? void 0 : i.trajectoryId) ? ye(i, e, t, n, l) && i.trajectoryId === r : !1;
}
function Ot(i, e) {
  return !!i && i.wellId === e && i.branch === "fact";
}
function ze(i, e) {
  return !!i && i.wellId === e && i.branch === "plan";
}
function $t(i, e, t) {
  return ze(i, e) && (i == null ? void 0 : i.designId) === t;
}
function He(i, e) {
  var t;
  return i.fact === void 0 ? [] : i.fact.length === 0 ? ((t = e == null ? void 0 : e.factWellbores) != null ? t : []).map((n) => ({ wellboreId: n.id, trajectories: [] })) : i.fact.map((n) => structuredClone(n));
}
function Ue(i, e) {
  var t;
  return i.plan === void 0 ? [] : i.plan.length === 0 ? ((t = e == null ? void 0 : e.planDesigns) != null ? t : []).map((n) => ({ designId: n.id, wellbores: [] })) : i.plan.map((n) => structuredClone(n));
}
function Vt(i, e) {
  return i.trajectories.length === 0 ? [...e] : i.trajectories.map((t) => t.trajectoryId);
}
function Qe(i, e) {
  return i.filter((t) => t.wellboreId !== e);
}
function et(i, e, t, n) {
  const r = i.find((a) => a.wellboreId === e);
  if (!r)
    return i;
  const l = new Set(Vt(r, n));
  l.delete(t);
  const s = i.filter((a) => a.wellboreId !== e);
  if (l.size === 0)
    return s;
  const o = n.length > 0 && l.size === n.length ? [] : Array.from(l).map((a) => ({ trajectoryId: a }));
  return s.push({ wellboreId: e, trajectories: o }), s;
}
function tt(i, e, t, n) {
  const r = i.find((a) => a.wellboreId === e), l = new Set(r ? Vt(r, n) : []);
  l.add(t);
  const s = i.filter((a) => a.wellboreId !== e), o = n.length > 0 && l.size === n.length ? [] : Array.from(l).map((a) => ({ trajectoryId: a }));
  return s.push({ wellboreId: e, trajectories: o }), s;
}
function zt(i, e) {
  var t, n;
  return (n = (t = i == null ? void 0 : i.factWellbores.find((r) => r.id === e)) == null ? void 0 : t.trajectories.map((r) => r.id)) != null ? n : [];
}
function Ht(i, e, t) {
  var n, r, l;
  return (l = (r = (n = i == null ? void 0 : i.planDesigns.find((s) => s.id === e)) == null ? void 0 : n.wellbores.find((s) => s.id === t)) == null ? void 0 : r.trajectories.map((s) => s.id)) != null ? l : [];
}
function Bi(i, e, t) {
  var u;
  const n = structuredClone(i);
  if (e.branch === "fact") {
    if (n.fact === void 0)
      return n;
    const d = He(n, t), h = Qe(d, e.wellboreId);
    if (h.length === 0)
      delete n.fact;
    else if (t && h.length === t.factWellbores.length) {
      const m = h.every((f) => f.trajectories.length === 0);
      n.fact = m ? [] : h;
    } else
      n.fact = h;
    return n;
  }
  if (n.plan === void 0 || !w(e.designId))
    return n;
  const r = Ue(n, t), l = r.find((d) => d.designId === e.designId), s = t == null ? void 0 : t.planDesigns.find((d) => d.id === e.designId);
  if (!l)
    return n;
  const o = l.wellbores.length === 0 ? (u = s == null ? void 0 : s.wellbores.map((d) => ({
    wellboreId: d.id,
    trajectories: []
  }))) != null ? u : [] : l.wellbores, a = Qe(o, e.wellboreId), c = r.filter((d) => d.designId !== e.designId);
  if (a.length === 0)
    return c.length === 0 ? delete n.plan : n.plan = c, n;
  if (c.push({ designId: e.designId, wellbores: a }), t && c.length === t.planDesigns.length) {
    const d = c.every((h) => h.wellbores.length === 0);
    n.plan = d ? [] : c;
  } else
    n.plan = c;
  return n;
}
function nt(i, e) {
  return i.find((n) => n.wellboreId === e) ? i : [...i, { wellboreId: e, trajectories: [] }];
}
function Ut(i, e, t) {
  var u;
  const n = structuredClone(i);
  if (e.branch === "fact") {
    const d = He(n, t), h = w(e.trajectoryId) ? tt(
      d,
      e.wellboreId,
      e.trajectoryId,
      zt(t, e.wellboreId)
    ) : nt(d, e.wellboreId);
    if (t && h.length === t.factWellbores.length) {
      const m = h.every((f) => f.trajectories.length === 0);
      n.fact = m ? [] : h;
    } else
      n.fact = h;
    return n;
  }
  if (!w(e.designId))
    return n;
  const r = Ue(n, t), l = t == null ? void 0 : t.planDesigns.find((d) => d.id === e.designId), s = r.find((d) => d.designId === e.designId), o = s ? s.wellbores.length === 0 ? (u = l == null ? void 0 : l.wellbores.map((d) => ({
    wellboreId: d.id,
    trajectories: []
  }))) != null ? u : [] : s.wellbores.map((d) => structuredClone(d)) : [], a = w(e.trajectoryId) ? tt(
    o,
    e.wellboreId,
    e.trajectoryId,
    Ht(t, e.designId, e.wellboreId)
  ) : nt(o, e.wellboreId), c = r.filter((d) => d.designId !== e.designId);
  if (c.push({ designId: e.designId, wellbores: a }), t && c.length === t.planDesigns.length) {
    const d = c.every((h) => h.wellbores.length === 0);
    n.plan = d ? [] : c;
  } else
    n.plan = c;
  return n;
}
function Ke(i, e, t, n) {
  const l = G(i).wells.map((o) => structuredClone(o)), s = e && t && e.wellId === t.wellId && e.branch === t.branch && e.designId === t.designId && e.wellboreId === t.wellboreId;
  if (e && !Bt(e, t)) {
    const o = l.findIndex((a) => a.wellId === e.wellId);
    o >= 0 && (s ? l[o] = Oi(l[o], e, n(e.wellId)) : l[o] = Bi(l[o], e, n(e.wellId)));
  }
  if (t) {
    let o = l.findIndex((a) => a.wellId === t.wellId);
    o < 0 && (l.push({ wellId: t.wellId }), o = l.length - 1), l[o] = Ut(l[o], t, n(t.wellId));
  }
  return {
    wells: l.filter((o) => o.fact !== void 0 || o.plan !== void 0)
  };
}
function Oi(i, e, t) {
  var h;
  if (!w(e.trajectoryId))
    return i;
  const n = structuredClone(i), r = e.trajectoryId;
  if (e.branch === "fact") {
    if (n.fact === void 0)
      return n;
    const m = He(n, t), f = zt(t, e.wellboreId), S = et(m, e.wellboreId, r, f);
    if (S.length === 0)
      delete n.fact;
    else if (t && S.length === t.factWellbores.length) {
      const W = S.every((v) => v.trajectories.length === 0);
      n.fact = W ? [] : S;
    } else
      n.fact = S;
    return n;
  }
  if (n.plan === void 0 || !w(e.designId))
    return n;
  const l = Ue(n, t), s = l.find((m) => m.designId === e.designId), o = t == null ? void 0 : t.planDesigns.find((m) => m.id === e.designId);
  if (!s)
    return n;
  const a = s.wellbores.length === 0 ? (h = o == null ? void 0 : o.wellbores.map((m) => ({
    wellboreId: m.id,
    trajectories: []
  }))) != null ? h : [] : s.wellbores, c = Ht(t, e.designId, e.wellboreId), u = et(a, e.wellboreId, r, c), d = l.filter((m) => m.designId !== e.designId);
  if (u.length === 0)
    return d.length === 0 ? delete n.plan : n.plan = d, n;
  if (d.push({ designId: e.designId, wellbores: u }), t && d.length === t.planDesigns.length) {
    const m = d.every((f) => f.wellbores.length === 0);
    n.plan = m ? [] : d;
  } else
    n.plan = d;
  return n;
}
function $i(i, e, t) {
  return e ? Ke(i, null, e, t) : G(i);
}
function it(i, e, t) {
  return !e || e.wellId !== i.wellId ? i : Ut(i, e, t);
}
const Vi = "active-status-icon-module__wrap__QpGQJ", zi = "active-status-icon-module__icon__KxppE", rt = {
  wrap: Vi,
  icon: zi
};
function Hi({ className: i }) {
  const { t: e } = N(), t = e("Filters.statusActive");
  return /* @__PURE__ */ p("span", { className: D(rt.wrap, i), title: t, "aria-label": t, children: /* @__PURE__ */ p(mn, { className: rt.icon }) });
}
const Ui = "redrilling-badge-module__badge__mnr97", Ki = {
  badge: Ui
};
function Yi({ redrillingIndex: i, backgroundColor: e, className: t }) {
  const { t: n } = N();
  return /* @__PURE__ */ P(
    "span",
    {
      className: D("dash-body-regular", Ki.badge, t),
      style: e ? { backgroundColor: e } : void 0,
      children: [
        n("Panel.redrill"),
        " ",
        i
      ]
    }
  );
}
const Xi = [
  "rgba(255, 105, 180, 0.3)",
  "rgba(111, 207, 151, 0.3)",
  "rgba(125, 168, 255, 0.3)",
  "rgba(242, 153, 74, 0.3)",
  "rgba(155, 89, 182, 0.3)",
  "rgba(38, 198, 218, 0.3)",
  "rgba(255, 214, 102, 0.3)",
  "rgba(235, 87, 87, 0.3)",
  "rgba(178, 136, 255, 0.3)",
  "rgba(168, 196, 88, 0.3)"
];
function Zi(i) {
  var n;
  const e = Xi;
  if (e.length === 0)
    return "transparent";
  const t = Math.max(0, i) % e.length;
  return (n = e[t]) != null ? n : e[0];
}
function Ji(i) {
  const e = /* @__PURE__ */ new Map();
  for (const r of i) {
    if (!w(r.redrillingIndex) || r.typeInstanceId == null)
      continue;
    const l = e.get(r.typeInstanceId);
    (!l || r.typeIndex < l.typeIndex) && e.set(r.typeInstanceId, { typeIndex: r.typeIndex });
  }
  const t = [...e.entries()].sort((r, l) => {
    const s = r[1].typeIndex - l[1].typeIndex;
    return s !== 0 ? s : r[0] - l[0];
  }).map(([r]) => r), n = /* @__PURE__ */ new Map();
  return t.forEach((r, l) => {
    n.set(r, Zi(l));
  }), n;
}
function Ce(i) {
  const { isActive: e, redrillBadge: t } = i;
  if (!(!t && !e))
    return /* @__PURE__ */ P(Q, { children: [
      t,
      e ? /* @__PURE__ */ p(Hi, {}) : null
    ] });
}
const lt = L(function({
  store: e,
  wellId: t,
  wellbores: n,
  disabled: r,
  forced: l,
  redrillingColorsByTypeInstanceId: s
}) {
  return n.map(({ wellbore: o, checkState: a, trajectories: c }) => {
    const u = ye(l, t, "fact", o.id), d = r || u, h = o.typeInstanceId != null ? s.get(o.typeInstanceId) : void 0, m = w(o.redrillingIndex) ? /* @__PURE__ */ p(Yi, { redrillingIndex: o.redrillingIndex, backgroundColor: h }) : void 0;
    return /* @__PURE__ */ p(
      U,
      {
        label: o.name,
        checked: B(a) || u,
        intermediate: ee(a) && !u,
        disabled: d,
        expandable: c.length > 0,
        expanded: e.isWellboreExpanded(t, "fact", o.id),
        trailing: Ce({ isActive: o.isActive, redrillBadge: m }),
        onCheckedChange: d ? void 0 : (f) => e.setFactWellboreChecked(t, o.id, f),
        onExpandToggle: () => e.toggleWellboreExpanded(t, "fact", o.id),
        children: c.map(({ trajectory: f, checkState: S }) => {
          const W = Ve(l, t, "fact", o.id, f.id), v = r || W;
          return /* @__PURE__ */ p(
            U,
            {
              label: f.name,
              checked: B(S) || W,
              disabled: v,
              trailing: Ce({ isActive: f.isActive }),
              onCheckedChange: v ? void 0 : (R) => e.setFactTrajectoryChecked(t, o.id, f.id, R)
            },
            `fact-traj-${f.id}`
          );
        })
      },
      `fact-wb-${o.id}`
    );
  });
}), st = L(function({
  store: e,
  wellId: t,
  designs: n,
  disabled: r,
  forced: l
}) {
  return n.map(({ design: s, checkState: o, wellbores: a }) => {
    const c = $t(l, t, s.id), u = r || c;
    return /* @__PURE__ */ p(
      U,
      {
        label: s.name,
        checked: B(o) || c,
        intermediate: ee(o) && !c,
        disabled: u,
        expandable: a.length > 0,
        expanded: e.isDesignExpanded(t, s.id),
        onCheckedChange: u ? void 0 : (d) => e.setDesignChecked(t, s.id, d),
        onExpandToggle: () => e.toggleDesignExpanded(t, s.id),
        children: a.map(({ wellbore: d, checkState: h, trajectories: m }) => {
          const f = ye(l, t, "plan", d.id, s.id), S = r || f;
          return /* @__PURE__ */ p(
            U,
            {
              label: d.name,
              checked: B(h) || f,
              intermediate: ee(h) && !f,
              disabled: S,
              expandable: m.length > 0,
              expanded: e.isWellboreExpanded(t, "plan", d.id, s.id),
              trailing: Ce({ isActive: d.isActive }),
              onCheckedChange: S ? void 0 : (W) => e.setPlanWellboreChecked(t, s.id, d.id, W),
              onExpandToggle: () => e.toggleWellboreExpanded(t, "plan", d.id, s.id),
              children: m.map(({ trajectory: W, checkState: v }) => {
                const R = Ve(
                  l,
                  t,
                  "plan",
                  d.id,
                  W.id,
                  s.id
                ), O = r || R;
                return /* @__PURE__ */ p(
                  U,
                  {
                    label: W.name,
                    checked: B(v) || R,
                    disabled: O,
                    trailing: Ce({ isActive: W.isActive }),
                    onCheckedChange: O ? void 0 : (ie) => e.setPlanTrajectoryChecked(t, s.id, d.id, W.id, ie)
                  },
                  `plan-traj-${s.id}-${W.id}`
                );
              })
            },
            `plan-wb-${s.id}-${d.id}`
          );
        })
      },
      `design-${s.id}`
    );
  });
}), ot = L(function({
  store: e,
  wellId: t,
  planCheckState: n,
  factCheckState: r,
  disabled: l = !1
}) {
  var v, R;
  const { t: s } = N(), { fact: o, plan: a, showFactGroup: c, showPlanGroup: u } = e.getVisibleWellBranch(t), d = e.forcedPrimarySelection, h = Ji(
    (R = (v = e.getWellChildren(t)) == null ? void 0 : v.factWellbores) != null ? R : []
  ), m = Ot(d, t), f = ze(d, t), S = l || m, W = l || f;
  return /* @__PURE__ */ P(Q, { children: [
    o !== null && (c ? /* @__PURE__ */ p(
      U,
      {
        label: s("Panel.fact"),
        checked: B(r) || m,
        intermediate: ee(r) && !m,
        disabled: S,
        expandable: o.length > 0,
        expanded: e.isFactExpanded(t),
        onCheckedChange: S ? void 0 : (O) => e.setFactChecked(t, O),
        onExpandToggle: () => e.toggleFactExpanded(t),
        children: /* @__PURE__ */ p(
          lt,
          {
            store: e,
            wellId: t,
            wellbores: o,
            disabled: l,
            forced: d,
            redrillingColorsByTypeInstanceId: h
          }
        )
      }
    ) : /* @__PURE__ */ p(
      lt,
      {
        store: e,
        wellId: t,
        wellbores: o,
        disabled: l,
        forced: d,
        redrillingColorsByTypeInstanceId: h
      }
    )),
    a !== null && (u ? /* @__PURE__ */ p(
      U,
      {
        label: s("Panel.plan"),
        checked: B(n) || f,
        intermediate: ee(n) && !f,
        disabled: W,
        expandable: a.length > 0,
        expanded: e.isPlanExpanded(t),
        onCheckedChange: W ? void 0 : (O) => e.setPlanChecked(t, O),
        onExpandToggle: () => e.togglePlanExpanded(t),
        children: /* @__PURE__ */ p(st, { store: e, wellId: t, designs: a, disabled: l, forced: d })
      }
    ) : /* @__PURE__ */ p(st, { store: e, wellId: t, designs: a, disabled: l, forced: d }))
  ] });
}), qi = { title: "Offset wells", tabWells: "Wells", tabGroups: "Groups", primaryWell: "Active well", plan: "Plan", fact: "Fact", loading: "Loading…", all: "Offset wells", emptyNameFallback: "—", searchPlaceholder: "Search wells", redrill: "Redrill" }, Qi = { title: "Filters", statusActive: "Active", statusCompleted: "Completed" }, er = { public: "Public", personal: "Personal", empty: "No groups yet", loading: "Loading…" }, tr = { menu: "Actions", apply: "Apply", rename: "Edit", copyToPublic: "Copy to public", copyToPersonal: "Copy to personal", delete: "Delete", addFavorite: "Add to favorites", removeFavorite: "Remove from favorites" }, nr = { name: "Name", namePlaceholder: "Enter a name", description: "Description", descriptionPlaceholder: "Enter a description", cancel: "Cancel", save: "Save" }, ir = { title: "Save", modeNew: "New group", modeExisting: "Existing group", personal: "Personal", public: "Public", group: "Group", groupPlaceholder: "Select a group" }, rr = { title: "Edit group" }, lr = { apply: "Apply", cancel: "Cancel", filter: "Filter", exportFilters: "Export filters", save: "Save" }, sr = { collapse: "Collapse", expand: "Expand" }, or = { close: "Close" }, ar = {
  Panel: qi,
  Filters: Qi,
  Groups: er,
  GroupActions: tr,
  GroupForm: nr,
  SaveModal: ir,
  RenameModal: rr,
  Footer: lr,
  Tree: sr,
  Header: or
}, cr = { title: "Pozos de referencia", tabWells: "Pozos", tabGroups: "Grupos", primaryWell: "Pozo activo", plan: "Plan", fact: "Hecho", loading: "Cargando…", all: "Pozos de referencia", emptyNameFallback: "—", searchPlaceholder: "Buscar pozos", redrill: "Redrill" }, dr = { title: "Filtros", statusActive: "Activos", statusCompleted: "Finalizados" }, pr = { public: "Públicos", personal: "Personales", empty: "Aún no hay grupos", loading: "Cargando…" }, ur = { menu: "Acciones", apply: "Aplicar", rename: "Editar", copyToPublic: "Copiar a públicos", copyToPersonal: "Copiar a personales", delete: "Eliminar", addFavorite: "Añadir a favoritos", removeFavorite: "Quitar de favoritos" }, hr = { name: "Nombre", namePlaceholder: "Introduzca un nombre", description: "Descripción", descriptionPlaceholder: "Introduzca una descripción", cancel: "Cancelar", save: "Guardar" }, fr = { title: "Guardar", modeNew: "Grupo nuevo", modeExisting: "Grupo existente", personal: "Personales", public: "Públicos", group: "Grupo", groupPlaceholder: "Seleccione un grupo" }, mr = { title: "Editar grupo" }, gr = { apply: "Aplicar", cancel: "Cancelar", filter: "Filtrar", exportFilters: "Exportar filtros", save: "Guardar" }, br = { collapse: "Contraer", expand: "Expandir" }, yr = { close: "Cerrar" }, Ir = {
  Panel: cr,
  Filters: dr,
  Groups: pr,
  GroupActions: ur,
  GroupForm: hr,
  SaveModal: fr,
  RenameModal: mr,
  Footer: gr,
  Tree: br,
  Header: yr
}, vr = { title: "Опорные скважины", tabWells: "Скважины", tabGroups: "Группы", primaryWell: "Активная скважина", plan: "План", fact: "Факт", loading: "Загрузка…", all: "Опорные скважины", emptyNameFallback: "—", searchPlaceholder: "Поиск скважин", redrill: "Перебур" }, Sr = { title: "Фильтры", statusActive: "Активные", statusCompleted: "Законченные" }, wr = { public: "Общие", personal: "Личные", empty: "Групп пока нет", loading: "Загрузка…" }, _r = { menu: "Действия", apply: "Применить", rename: "Редактировать", copyToPublic: "Копировать в общие", copyToPersonal: "Копировать в личные", delete: "Удалить", addFavorite: "В избранное", removeFavorite: "Убрать из избранного" }, Wr = { name: "Название", namePlaceholder: "Введите название", description: "Описание", descriptionPlaceholder: "Введите описание", cancel: "Отмена", save: "Сохранить" }, Tr = { title: "Сохранить", modeNew: "Новая группа", modeExisting: "Существующая группа", personal: "Персональные", public: "Публичные", group: "Группа", groupPlaceholder: "Выберите группу" }, Fr = { title: "Редактировать группу" }, Cr = { apply: "Применить", cancel: "Отменить", filter: "Отфильтровать", exportFilters: "Экспорт фильтров", save: "Сохранить" }, xr = { collapse: "Свернуть", expand: "Развернуть" }, Pr = { close: "Закрыть" }, kr = {
  Panel: vr,
  Filters: Sr,
  Groups: wr,
  GroupActions: _r,
  GroupForm: Wr,
  SaveModal: Tr,
  RenameModal: Fr,
  Footer: Cr,
  Tree: xr,
  Header: Pr
}, we = "referenceWells";
function Dr(i) {
  const e = gn.createInstance();
  if (e.use(rn).init({
    resources: {
      en: { [we]: ar },
      ru: { [we]: kr },
      es: { [we]: Ir }
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: we,
    interpolation: {
      escapeValue: !1
    }
  }), i) {
    const t = e.t.bind(e);
    e.t = ((n, r) => {
      const l = Array.isArray(n) ? String(n[0]) : String(n);
      return e.exists(l) ? t(n, r) : i.exists(l) ? i.t(l, r) : t(n, r);
    });
  }
  return e;
}
function Er({ language: i, parentI18n: e, children: t }) {
  const n = Pe(() => Dr(e), [e]);
  return Me(() => {
    n.changeLanguage(i);
  }, [n, i]), /* @__PURE__ */ p(ln, { i18n: n, children: t });
}
const Gr = "reference-wells-panel-module__panel__dv9xf", Ar = "reference-wells-panel-module__panelEmbedded__qPp8D", jr = "reference-wells-panel-module__tabsBar__OWuZO", Nr = "reference-wells-panel-module__tabs__Wbb9b", Rr = "reference-wells-panel-module__sectionLabel__vZnmf", Mr = "reference-wells-panel-module__previewTree__86tbs", Lr = "reference-wells-panel-module__treeArea__ZtlpD", Br = "reference-wells-panel-module__scrollbar__g6FrG", Or = "reference-wells-panel-module__treeList__F5BGv", $r = "reference-wells-panel-module__loadingPlaceholder__E5FUI", V = {
  panel: Gr,
  panelEmbedded: Ar,
  tabsBar: jr,
  tabs: Nr,
  sectionLabel: Rr,
  previewTree: Mr,
  treeArea: Lr,
  scrollbar: Br,
  treeList: Or,
  loadingPlaceholder: $r
}, Vr = L(function({
  store: e,
  templatesStore: t,
  primaryWellName: n = null,
  showHeader: r = !0,
  onClose: l
}) {
  const { t: s } = N(), [o, a] = le("wells"), c = e.primaryWellId, u = e.primaryWell, d = e.wellTreeRows, h = e.isLoading, m = (n == null ? void 0 : n.trim()) || (u == null ? void 0 : u.name) || (w(c) ? String(c) : s("Panel.emptyNameFallback")), f = Pe(
    () => [
      { value: "wells", label: s("Panel.tabWells") },
      { value: "groups", label: s("Panel.tabGroups") }
    ],
    [s]
  ), S = w(c) ? e.getWellChildren(c) : void 0, W = w(c) ? e.selectedTree.wells.find((E) => E.wellId === c) : void 0, v = e.lockPrimaryWellSubtree, R = w(c) ? $e(e.selectedTree, c, S, e.visibility) : "unchecked", O = Oe(W, S, e.visibility), ie = Be(W, S, e.visibility);
  return /* @__PURE__ */ P("aside", { className: D(V.panel, !r && V.panelEmbedded), children: [
    r && /* @__PURE__ */ p(Wi, { title: s("Panel.title"), onClose: l }),
    /* @__PURE__ */ p("div", { className: V.tabsBar, children: /* @__PURE__ */ p(Wt, { size: "s", value: o, items: f, onChange: a, className: V.tabs }) }),
    o === "wells" ? /* @__PURE__ */ P(Q, { children: [
      /* @__PURE__ */ p("div", { className: D("dash-body-bold", V.sectionLabel), children: s("Panel.primaryWell") }),
      /* @__PURE__ */ p("div", { className: V.previewTree, children: w(c) ? /* @__PURE__ */ p(
        U,
        {
          label: m,
          checked: B(R),
          intermediate: ee(R),
          disabled: !0,
          expandable: !v && e.wellHasVisibleChildren(c),
          expanded: !v && e.primaryExpanded,
          onExpandToggle: v ? void 0 : e.togglePrimaryExpanded,
          icon: u ? /* @__PURE__ */ p(qe, { status: u.status }) : void 0,
          children: !v && /* @__PURE__ */ p(
            ot,
            {
              store: e,
              wellId: c,
              planCheckState: O,
              factCheckState: ie
            }
          )
        }
      ) : /* @__PURE__ */ p("span", { className: D("dash-body-regular", V.loadingPlaceholder), children: s("Panel.emptyNameFallback") }) }),
      /* @__PURE__ */ p(Ln, { store: e }),
      /* @__PURE__ */ p(xi, { store: e }),
      /* @__PURE__ */ p("div", { className: V.treeArea, children: /* @__PURE__ */ p(en, { className: V.scrollbar, children: /* @__PURE__ */ p("div", { className: V.treeList, children: h && d.length === 0 ? /* @__PURE__ */ p("span", { className: D("dash-body-regular", V.loadingPlaceholder), children: s("Panel.loading") }) : /* @__PURE__ */ p(
        U,
        {
          label: s("Panel.all"),
          bold: !0,
          checked: e.allChecked,
          intermediate: e.allIntermediate,
          expanded: e.rootExpanded,
          expandable: d.length > 0,
          onCheckedChange: e.setAllChecked,
          onExpandToggle: e.toggleRootExpanded,
          children: d.map((E) => /* @__PURE__ */ p(
            U,
            {
              label: E.well.name,
              checked: B(E.checkState),
              intermediate: ee(E.checkState),
              expandable: E.hasVisibleChildren,
              expanded: E.expanded,
              onCheckedChange: (ce) => e.setWellChecked(E.well.id, ce),
              onExpandToggle: () => e.toggleWellExpanded(E.well.id),
              icon: /* @__PURE__ */ p(qe, { status: E.well.status }),
              children: /* @__PURE__ */ p(
                ot,
                {
                  store: e,
                  wellId: E.well.id,
                  planCheckState: E.planCheckState,
                  factCheckState: E.factCheckState
                }
              )
            },
            E.well.id
          ))
        }
      ) }) }) }),
      /* @__PURE__ */ p(Ii, { store: e, templatesStore: t })
    ] }) : /* @__PURE__ */ p(ai, { templatesStore: t })
  ] });
});
function _l({ language: i, parentI18n: e, ...t }) {
  return /* @__PURE__ */ p(Er, { language: i, parentI18n: e, children: /* @__PURE__ */ p(Vr, { ...t }) });
}
function zr(i) {
  const e = i.find((n) => n.isActive);
  if (e)
    return e;
  const t = i.find(
    (n) => n.typeSlug.toLowerCase() === "main" && n.redrillingIndex === null
  );
  return t || (i.length > 0 ? i[0] : null);
}
var Hr = Object.defineProperty, Ur = Object.getOwnPropertyDescriptor, A = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? Ur(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && Hr(e, t, r), r;
};
function Kr(i) {
  return {
    ...K,
    ...i
  };
}
class j {
  constructor(e) {
    I(this, "wellsSource");
    I(this, "onSelectionChange");
    I(this, "disposed", !1);
    I(this, "_primaryWellId");
    I(this, "_selectedTree");
    I(this, "_visibility");
    I(this, "_wellChildrenByWellId", /* @__PURE__ */ new Map());
    I(this, "_forcedPrimarySelection", null);
    I(this, "_lockPrimaryWellSubtree");
    var t, n, r;
    this.wellsSource = e.wellsSource, this.onSelectionChange = (t = e.onSelectionChange) != null ? t : null, this._primaryWellId = (n = e.primaryWellId) != null ? n : null, this._visibility = Kr(e.visibility), this._lockPrimaryWellSubtree = (r = e.lockPrimaryWellSubtree) != null ? r : !1, this._selectedTree = Fe(), Ie(this), e.initialSelectedTree && this.setSelectedTree(e.initialSelectedTree);
  }
  get wellsSourceRef() {
    return this.wellsSource;
  }
  get primaryWellId() {
    return this._primaryWellId;
  }
  get selectedTree() {
    return this._selectedTree;
  }
  /**
   * Explicit selected ids only (no whole-branch `[]` shorthand).
   * Use for widget consumers; omit unselected fact/plan branches.
   */
  getSelectedTreeForConsumers() {
    return xn(
      this._selectedTree,
      (e) => this._wellChildrenByWellId.get(e),
      this._visibility
    );
  }
  get visibility() {
    return this._visibility;
  }
  get lockPrimaryWellSubtree() {
    return this._lockPrimaryWellSubtree;
  }
  get forcedPrimarySelection() {
    return this._forcedPrimarySelection;
  }
  get wellChildrenByWellId() {
    return this._wellChildrenByWellId;
  }
  getWellChildren(e) {
    return this._wellChildrenByWellId.get(e);
  }
  setOnSelectionChange(e) {
    this.onSelectionChange = e;
  }
  setPrimaryWellId(e) {
    this._primaryWellId = e;
  }
  setAllWellChildren(e) {
    this._wellChildrenByWellId = new Map(e), this.setSelectedTree(this._selectedTree);
  }
  ensureDefaultPrimaryWellboreSelection() {
    if (this.disposed || !this._visibility.showFact)
      return !1;
    const e = this._primaryWellId;
    if (!w(e))
      return !1;
    const t = this._forcedPrimarySelection;
    if (t && t.wellId === e)
      return !1;
    const n = this._selectedTree.wells.find((a) => a.wellId === e);
    if ((n == null ? void 0 : n.fact) !== void 0)
      return !1;
    const r = this._wellChildrenByWellId.get(e), l = r ? zr(r.factWellbores) : null;
    if (!l)
      return !1;
    const s = G(this._selectedTree).wells, o = s.find((a) => a.wellId === e);
    return o ? o.fact = [{ wellboreId: l.id, trajectories: [] }] : s.push({
      wellId: e,
      fact: [{ wellboreId: l.id, trajectories: [] }]
    }), this.setSelectedTree({ wells: s }), !0;
  }
  setForcedPrimarySelection(e) {
    this.assertAlive();
    const t = this._forcedPrimarySelection;
    if (Bt(t, e))
      return;
    const n = Ke(
      this._selectedTree,
      t,
      e,
      (r) => this._wellChildrenByWellId.get(r)
    );
    this._forcedPrimarySelection = Li(e), this.setSelectedTree(n);
  }
  setSelectedTree(e) {
    this.assertAlive();
    const t = (l) => this._wellChildrenByWellId.get(l), n = $i(e, this._forcedPrimarySelection, t), r = jt(n, t, this._visibility);
    this._selectedTree = G(r), this.notifySelectionChange();
  }
  dispose() {
    this.disposed || (this.disposed = !0, this.onSelectionChange = null);
  }
  notifySelectionChange() {
    var e;
    (e = this.onSelectionChange) == null || e.call(this, this.getSelectedTreeForConsumers());
  }
  assertAlive() {
    if (this.disposed)
      throw new Error("ReferenceWellsService is disposed");
  }
}
A([
  T.ref
], j.prototype, "_primaryWellId", 2);
A([
  T.ref
], j.prototype, "_selectedTree", 2);
A([
  T.ref
], j.prototype, "_visibility", 2);
A([
  T.ref
], j.prototype, "_wellChildrenByWellId", 2);
A([
  T.ref
], j.prototype, "_forcedPrimarySelection", 2);
A([
  _
], j.prototype, "primaryWellId", 1);
A([
  _
], j.prototype, "selectedTree", 1);
A([
  _
], j.prototype, "visibility", 1);
A([
  _
], j.prototype, "forcedPrimarySelection", 1);
A([
  _
], j.prototype, "wellChildrenByWellId", 1);
A([
  y.bound
], j.prototype, "setOnSelectionChange", 1);
A([
  y.bound
], j.prototype, "setPrimaryWellId", 1);
A([
  y.bound
], j.prototype, "setAllWellChildren", 1);
A([
  y.bound
], j.prototype, "ensureDefaultPrimaryWellboreSelection", 1);
A([
  y.bound
], j.prototype, "setForcedPrimarySelection", 1);
A([
  y.bound
], j.prototype, "setSelectedTree", 1);
A([
  y.bound
], j.prototype, "dispose", 1);
function q(i, e) {
  return e.length === 0 ? !0 : i == null ? !1 : e.includes(i);
}
function at(i, e) {
  var t, n, r, l, s, o, a, c, u, d;
  if (!e || he(e))
    return !0;
  if (e.status.length > 0) {
    const h = i.status.toLowerCase();
    if (!e.status.some((f) => h.includes(f.toString().toLowerCase())))
      return !1;
  }
  return !(!q((r = (t = i.block) == null ? void 0 : t.organizationId) != null ? r : (n = i.organization) == null ? void 0 : n.id, e.organizationId) || !q((l = i.block) == null ? void 0 : l.id, e.blockId) || !q((s = i.field) == null ? void 0 : s.id, e.fieldId) || !q((a = i.padId) != null ? a : (o = i.pad) == null ? void 0 : o.id, e.padId) || !q(i.id, e.wellId) || !q((c = i.rigModel) == null ? void 0 : c.id, e.rigModelId) || !q((d = i.brigadeId) != null ? d : (u = i.brigade) == null ? void 0 : u.id, e.brigadeId));
}
function We(i, e) {
  return !e || e.wellboreTypeInstanceId.length === 0 ? !0 : q(i.typeInstanceId, e.wellboreTypeInstanceId);
}
function ct(i, e) {
  return e ? {
    wellbore: i,
    trajectories: [...i.trajectories]
  } : {
    wellbore: i,
    trajectories: []
  };
}
function dt(i, e, t) {
  return i.filter((n) => t != null && n.id === t ? !0 : We(n, e != null ? e : null));
}
function Yr(i, e, t = null, n = null) {
  const r = (() => {
    var c;
    return e.showFact ? e.showWellbores ? dt((c = i == null ? void 0 : i.factWellbores) != null ? c : [], t, n).map(
      (u) => ct(u, e.showTrajectories)
    ) : [] : null;
  })(), l = (() => {
    var c;
    return e.showPlan ? ((c = i == null ? void 0 : i.planDesigns) != null ? c : []).map((u) => ({
      design: u,
      wellbores: e.showWellbores ? dt(u.wellbores, t, n).map(
        (d) => ct(d, e.showTrajectories)
      ) : []
    })) : null;
  })(), s = e.showFact && e.showPlan;
  return { fact: r, plan: l, showFactGroup: s && r !== null, showPlanGroup: s && l !== null };
}
function pt(i) {
  return !!(i.showFactGroup || i.showPlanGroup || i.fact !== null && i.fact.length > 0 || i.plan !== null && i.plan.length > 0);
}
const oe = 1, ut = 0.5, ht = 0.2, xe = 0.1, Xr = 0.03, Zr = 0.02, Jr = 0.01;
function ft(i) {
  return i === "ACTIVE_GREEN" || i === "ACTIVE_YELLOW";
}
function mt(i) {
  return i < 0 ? -1 : i > 0 ? 1 : 0;
}
function Ye(i, e) {
  return i.localeCompare(e, void 0, { sensitivity: "base" }) * Jr;
}
function qr(i, e) {
  const t = se(i.checkState) ? oe : 0, n = se(e.checkState) ? oe : 0, r = ft(i.status) ? ut : 0, l = ft(e.status) ? ut : 0;
  return n - t + (l - r) + Ye(i.name, e.name);
}
function gt(i, e) {
  const t = se(i.checkState) ? oe : 0, n = se(e.checkState) ? oe : 0, r = i.isActive ? xe : 0, l = e.isActive ? xe : 0;
  return n - t + (l - r) + Ye(i.name, e.name);
}
function bt(i, e) {
  var u, d;
  const t = se(i.checkState) ? oe : 0, n = se(e.checkState) ? oe : 0, r = i.typeSlug.toLowerCase() === "main" ? ht : 0, l = e.typeSlug.toLowerCase() === "main" ? ht : 0, s = i.isActive ? xe : 0, o = e.isActive ? xe : 0, a = mt(i.typeIndex - e.typeIndex) * Xr, c = mt(((u = i.redrillingIndex) != null ? u : 0) - ((d = e.redrillingIndex) != null ? d : 0)) * Zr;
  return n - t + (l - r) + (o - s) + a + c + Ye(i.name, e.name);
}
var Qr = Object.defineProperty, el = Object.getOwnPropertyDescriptor, g = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? el(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && Qr(e, t, r), r;
};
function ue(i) {
  return structuredClone(i);
}
class b {
  constructor(e, t) {
    I(this, "service");
    I(this, "filtersHostBridge");
    I(this, "_draftTree");
    I(this, "_filters");
    I(this, "expandedWellIds");
    I(this, "expandedFactWellIds");
    I(this, "expandedPlanWellIds");
    I(this, "expandedDesignKeys");
    I(this, "expandedWellboreKeys");
    I(this, "rootExpanded", !0);
    I(this, "primaryExpanded", !0);
    I(this, "searchValue", "");
    I(this, "pendingPersistedSettings", null);
    var n, r;
    this.service = e, this.filtersHostBridge = (n = t == null ? void 0 : t.filtersHostBridge) != null ? n : null, this._filters = J((r = t == null ? void 0 : t.initialFilters) != null ? r : null), this._draftTree = G(e.selectedTree), this.expandedWellIds = T.set(), this.expandedFactWellIds = T.set(), this.expandedPlanWellIds = T.set(), this.expandedDesignKeys = T.set(), this.expandedWellboreKeys = T.set(), Ie(this), t != null && t.persistedSettingsToRestore && (this.pendingPersistedSettings = {
      tree: G(t.persistedSettingsToRestore.tree),
      filters: J(t.persistedSettingsToRestore.filters)
    }), !this.pendingPersistedSettings && this._filters && !he(this._filters) && this.commitPrunedSelection(this._draftTree);
  }
  setFiltersHostBridge(e) {
    this.filtersHostBridge = e;
  }
  get filters() {
    return this._filters;
  }
  get wellsSourceAllWells() {
    return this.service.wellsSourceRef.allWells;
  }
  get hasFiltersHost() {
    var e, t;
    return (t = (e = this.filtersHostBridge) == null ? void 0 : e.hasFiltersWidget) != null ? t : !1;
  }
  /** Versioned settings snapshot for gostorage (tree + filters). */
  getSettingsSnapshot() {
    return Gt(
      this.service.selectedTree,
      this._filters,
      (e) => this.service.getWellChildren(e),
      this.visibility
    );
  }
  get primaryWellId() {
    return this.service.primaryWellId;
  }
  get visibility() {
    return this.service.visibility;
  }
  get lockPrimaryWellSubtree() {
    return this.service.lockPrimaryWellSubtree;
  }
  get forcedPrimarySelection() {
    return this.service.forcedPrimarySelection;
  }
  isPrimarySubtreeLocked(e) {
    return this.lockPrimaryWellSubtree && e === this.primaryWellId;
  }
  isWellboreForced(e, t, n, r) {
    return ye(this.forcedPrimarySelection, e, t, n, r);
  }
  isTrajectoryForced(e, t, n, r, l) {
    return Ve(this.forcedPrimarySelection, e, t, n, r, l);
  }
  isFactBranchForced(e) {
    return Ot(this.forcedPrimarySelection, e);
  }
  isPlanBranchForced(e) {
    return ze(this.forcedPrimarySelection, e);
  }
  isDesignForced(e, t) {
    return $t(this.forcedPrimarySelection, e, t);
  }
  setForcedPrimarySelection(e) {
    const t = this.service.forcedPrimarySelection;
    this.service.setForcedPrimarySelection(e);
    const n = Ke(
      this._draftTree,
      t,
      this.service.forcedPrimarySelection,
      (r) => this.service.getWellChildren(r)
    );
    this.setDraftTree(n);
  }
  get isLoading() {
    return this.service.wellsSourceRef.isLoading;
  }
  get selectedTree() {
    return this._draftTree;
  }
  get appliedTree() {
    return this.service.selectedTree;
  }
  get hasPendingSelectionChanges() {
    return !nn(this._draftTree, this.service.selectedTree);
  }
  get catalogWells() {
    const e = this.service.primaryWellId, t = this.searchValue.trim().toLowerCase(), n = this._filters;
    return this.service.wellsSourceRef.allWells.filter((r) => r.id === e || !at(r, n) ? !1 : t ? r.name.toLowerCase().includes(t) : !0);
  }
  get primaryWell() {
    var t;
    const e = this.service.primaryWellId;
    return w(e) && (t = this.service.wellsSourceRef.allWells.find((n) => n.id === e)) != null ? t : null;
  }
  get allCheckState() {
    return wn(
      this.selectedTree,
      this.catalogWells.map((e) => e.id),
      (e) => this.service.getWellChildren(e),
      this.visibility
    );
  }
  get allChecked() {
    return B(this.allCheckState);
  }
  get allIntermediate() {
    return ee(this.allCheckState);
  }
  get wellTreeRows() {
    const e = this.selectedTree, t = this.visibility;
    return this.catalogWells.map((n) => {
      const r = this.service.getWellChildren(n.id), l = e.wells.find((o) => o.wellId === n.id), s = $e(e, n.id, r, t);
      return {
        well: n,
        checkState: s,
        planCheckState: Oe(l, r, t),
        factCheckState: Be(l, r, t),
        expanded: this.expandedWellIds.has(n.id),
        children: r,
        hasVisibleChildren: pt(this.buildProjectedWellBranch(n.id, r))
      };
    }).sort(
      (n, r) => qr(
        { checkState: n.checkState, name: n.well.name, status: n.well.status },
        { checkState: r.checkState, name: r.well.name, status: r.well.status }
      )
    );
  }
  getWellChildren(e) {
    return this.service.getWellChildren(e);
  }
  getForcedWellboreIdForWell(e) {
    const t = this.service.forcedPrimarySelection;
    return !t || t.wellId !== e ? null : t.wellboreId;
  }
  buildProjectedWellBranch(e, t = this.getWellChildren(e)) {
    return Yr(t, this.visibility, this._filters, this.getForcedWellboreIdForWell(e));
  }
  wellHasVisibleChildren(e) {
    return pt(this.buildProjectedWellBranch(e));
  }
  /**
   * UI projection for one well: which Fact/Plan/wellbore/traj nodes to render under visibility,
   * with checkbox state and tree sort order. Does not mutate catalog or selection.
   */
  getVisibleWellBranch(e) {
    const t = this.buildProjectedWellBranch(e), n = t.fact === null ? null : new Set(t.fact.map((o) => o.wellbore.id)), r = t.fact === null ? null : new Map(t.fact.map((o) => [o.wellbore.id, new Set(o.trajectories.map((a) => a.id))])), l = n === null ? null : this.getSortedFactWellbores(e).filter((o) => n.has(o.wellbore.id)).map(({ wellbore: o, checkState: a }) => {
      const c = r == null ? void 0 : r.get(o.id);
      return {
        wellbore: o,
        checkState: a,
        trajectories: this.getSortedTrajectories(e, o.id, "fact").filter(
          (u) => c == null ? void 0 : c.has(u.trajectory.id)
        )
      };
    }), s = t.plan === null ? null : this.getSortedPlanDesigns(e).map(({ design: o, checkState: a }) => {
      var h, m;
      const c = t.plan.find((f) => f.design.id === o.id), u = new Set((h = c == null ? void 0 : c.wellbores.map((f) => f.wellbore.id)) != null ? h : []), d = new Map(
        ((m = c == null ? void 0 : c.wellbores) != null ? m : []).map((f) => [
          f.wellbore.id,
          new Set(f.trajectories.map((S) => S.id))
        ])
      );
      return {
        design: o,
        checkState: a,
        wellbores: this.getSortedDesignWellbores(e, o.id).filter((f) => u.has(f.wellbore.id)).map(({ wellbore: f, checkState: S }) => {
          const W = d.get(f.id);
          return {
            wellbore: f,
            checkState: S,
            trajectories: this.getSortedTrajectories(e, f.id, "plan", o.id).filter(
              (v) => W == null ? void 0 : W.has(v.trajectory.id)
            )
          };
        })
      };
    });
    return {
      fact: l,
      plan: s,
      showFactGroup: t.showFactGroup,
      showPlanGroup: t.showPlanGroup
    };
  }
  isFactExpanded(e) {
    return this.expandedFactWellIds.has(e);
  }
  isPlanExpanded(e) {
    return this.expandedPlanWellIds.has(e);
  }
  isDesignExpanded(e, t) {
    return this.expandedDesignKeys.has(`${e}:design:${t}`);
  }
  isWellboreExpanded(e, t, n, r) {
    const l = t === "plan" && w(r) ? `${e}:plan:${r}:wb:${n}` : `${e}:fact:wb:${n}`;
    return this.expandedWellboreKeys.has(l);
  }
  getSortedFactWellbores(e) {
    const t = this.service.getWellChildren(e), n = this.selectedTree.wells.find((o) => o.wellId === e), r = this.visibility, l = (n == null ? void 0 : n.fact) !== void 0 && n.fact.length === 0;
    if (!t)
      return [];
    const s = this.getForcedWellboreIdForWell(e);
    return t.factWellbores.filter(
      (o) => s != null && o.id === s || We(o, this._filters)
    ).map((o) => {
      const a = l ? "checked" : be(
        n == null ? void 0 : n.fact,
        o.id,
        o.trajectories.map((c) => c.id),
        r.showTrajectories
      );
      return { wellbore: o, checkState: a };
    }).sort(
      (o, a) => bt(
        {
          checkState: o.checkState,
          name: o.wellbore.name,
          isActive: o.wellbore.isActive,
          typeSlug: o.wellbore.typeSlug,
          typeIndex: o.wellbore.typeIndex,
          redrillingIndex: o.wellbore.redrillingIndex
        },
        {
          checkState: a.checkState,
          name: a.wellbore.name,
          isActive: a.wellbore.isActive,
          typeSlug: a.wellbore.typeSlug,
          typeIndex: a.wellbore.typeIndex,
          redrillingIndex: a.wellbore.redrillingIndex
        }
      )
    );
  }
  getSortedPlanDesigns(e) {
    const t = this.service.getWellChildren(e), n = this.selectedTree.wells.find((s) => s.wellId === e), r = this.visibility, l = (n == null ? void 0 : n.plan) !== void 0 && n.plan.length === 0;
    return t ? t.planDesigns.map((s) => ({
      design: s,
      checkState: l ? "checked" : Le(
        n == null ? void 0 : n.plan,
        s.id,
        s.wellbores,
        r.showTrajectories,
        r.showWellbores
      )
    })).sort(
      (s, o) => gt(
        { checkState: s.checkState, name: s.design.name, isActive: s.design.isActive },
        { checkState: o.checkState, name: o.design.name, isActive: o.design.isActive }
      )
    ) : [];
  }
  getSortedDesignWellbores(e, t) {
    var u;
    const n = this.service.getWellChildren(e), r = this.selectedTree.wells.find((d) => d.wellId === e), l = n == null ? void 0 : n.planDesigns.find((d) => d.id === t), s = (u = r == null ? void 0 : r.plan) == null ? void 0 : u.find((d) => d.designId === t), o = this.visibility;
    if (!l)
      return [];
    const a = (r == null ? void 0 : r.plan) !== void 0 && r.plan.length === 0 || s == null ? void 0 : s.wellbores, c = this.getForcedWellboreIdForWell(e);
    return l.wellbores.filter(
      (d) => c != null && d.id === c || We(d, this._filters)
    ).map((d) => {
      const h = (r == null ? void 0 : r.plan) !== void 0 && r.plan.length === 0, m = s !== void 0 && s.wellbores.length === 0;
      let f;
      return h || m ? f = "checked" : f = be(
        a,
        d.id,
        d.trajectories.map((S) => S.id),
        o.showTrajectories
      ), { wellbore: d, checkState: f };
    }).sort(
      (d, h) => bt(
        {
          checkState: d.checkState,
          name: d.wellbore.name,
          isActive: d.wellbore.isActive,
          typeSlug: d.wellbore.typeSlug,
          typeIndex: d.wellbore.typeIndex,
          redrillingIndex: d.wellbore.redrillingIndex
        },
        {
          checkState: h.checkState,
          name: h.wellbore.name,
          isActive: h.wellbore.isActive,
          typeSlug: h.wellbore.typeSlug,
          typeIndex: h.wellbore.typeIndex,
          redrillingIndex: h.wellbore.redrillingIndex
        }
      )
    );
  }
  getSortedTrajectories(e, t, n, r) {
    var d;
    const l = this.service.getWellChildren(e), s = this.selectedTree.wells.find((h) => h.wellId === e);
    let o, a;
    if (n === "fact")
      o = l == null ? void 0 : l.factWellbores.find((h) => h.id === t), a = s == null ? void 0 : s.fact;
    else if (w(r)) {
      const h = l == null ? void 0 : l.planDesigns.find((W) => W.id === r);
      o = h == null ? void 0 : h.wellbores.find((W) => W.id === t);
      const m = (d = s == null ? void 0 : s.plan) == null ? void 0 : d.find((W) => W.designId === r), f = (s == null ? void 0 : s.plan) !== void 0 && s.plan.length === 0, S = m !== void 0 && m.wellbores.length === 0;
      f || S ? a = o ? [{ wellboreId: t, trajectories: [] }] : void 0 : a = m == null ? void 0 : m.wellbores;
    }
    if (!o)
      return [];
    const u = (s == null ? void 0 : s.fact) !== void 0 && s.fact.length === 0 ? [{ wellboreId: t, trajectories: [] }] : a;
    return o.trajectories.map((h) => ({
      trajectory: h,
      checkState: Sn(u, t, h.id)
    })).sort(
      (h, m) => gt(
        {
          checkState: h.checkState,
          name: h.trajectory.name,
          isActive: h.trajectory.isActive
        },
        {
          checkState: m.checkState,
          name: m.trajectory.name,
          isActive: m.trajectory.isActive
        }
      )
    );
  }
  setSearchValue(e) {
    this.searchValue = e;
  }
  restorePersistedSettings(e) {
    this.pendingPersistedSettings = {
      tree: G(e.tree),
      filters: J(e.filters)
    }, this.service.wellChildrenByWellId.size > 0 && this.applyPendingPersistedSettingsIfNeeded();
  }
  setAllWellChildren(e) {
    this.service.setAllWellChildren(e), !this.applyPendingPersistedSettingsIfNeeded() && (this.syncDraftFromApplied(), this._filters && !he(this._filters) && this.commitPrunedSelection(this.service.selectedTree));
  }
  syncDraftFromApplied() {
    this._draftTree = G(this.service.selectedTree);
  }
  applyDraftSelection() {
    this.commitPrunedSelection(this._draftTree);
  }
  applySettingsFromGroup(e) {
    this._filters = J(e.filters), this._draftTree = G(e.tree), this.applyDraftSelection();
  }
  resetDraftSelection() {
    this._draftTree = G(this.service.selectedTree);
  }
  importFiltersFromHost() {
    var e;
    (e = this.filtersHostBridge) != null && e.hasFiltersWidget && (this._filters = J(this.filtersHostBridge.pullFilters()), this.applyDraftSelection());
  }
  exportFiltersToHost() {
    var e;
    !((e = this.filtersHostBridge) != null && e.hasFiltersWidget) || this._filters === null || this.filtersHostBridge.pushFilters(J(this._filters));
  }
  /** Prune by current filters and commit to service + draft. */
  commitPrunedSelection(e) {
    const t = this.pruneTreeByWellsFilters(e);
    this.service.setSelectedTree(t), this._draftTree = G(this.service.selectedTree);
  }
  /**
   * Drop non-primary wells that do not pass well filters, and prune wellbores
   * that do not pass wellboreTypeInstanceId (forced/primary wellbores kept).
   */
  pruneTreeByWellsFilters(e) {
    const t = this._filters;
    if (!t || he(t))
      return G(e);
    const n = new Map(this.service.wellsSourceRef.allWells.map((o) => [o.id, o])), r = this.service.primaryWellId, l = this.service.forcedPrimarySelection;
    return { wells: e.wells.filter((o) => {
      if (o.wellId === r)
        return !0;
      const a = n.get(o.wellId);
      return a ? at(a, t) : !0;
    }).map((o) => this.pruneWellSelectionByWellboreFilters(o, t, l)) };
  }
  pruneWellSelectionByWellboreFilters(e, t, n) {
    var o;
    if (t.wellboreTypeInstanceId.length === 0)
      return structuredClone(e);
    const r = this.service.getWellChildren(e.wellId), l = (a, c, u) => {
      var h;
      if (n && ye(n, e.wellId, c, a, u))
        return !0;
      const d = c === "fact" ? r == null ? void 0 : r.factWellbores.find((m) => m.id === a) : (h = r == null ? void 0 : r.planDesigns.find((m) => m.id === u)) == null ? void 0 : h.wellbores.find((m) => m.id === a);
      return d ? We(d, t) : r == null;
    }, s = { wellId: e.wellId };
    if (e.fact !== void 0)
      if (e.fact.length === 0)
        if (!r)
          s.fact = [];
        else {
          const a = r.factWellbores.filter((c) => l(c.id, "fact")).map((c) => ({ wellboreId: c.id, trajectories: [] }));
          a.length === 0 || (a.length === r.factWellbores.length ? s.fact = [] : s.fact = a);
        }
      else {
        const a = e.fact.filter((c) => l(c.wellboreId, "fact"));
        a.length > 0 && (s.fact = a.map((c) => structuredClone(c)));
      }
    if (e.plan !== void 0)
      if (e.plan.length === 0)
        if (!r)
          s.plan = [];
        else {
          const a = r.planDesigns.map((c) => {
            const u = c.wellbores.filter((d) => l(d.id, "plan", c.id)).map((d) => ({ wellboreId: d.id, trajectories: [] }));
            return u.length === 0 ? null : u.length === c.wellbores.length ? { designId: c.id, wellbores: [] } : { designId: c.id, wellbores: u };
          }).filter((c) => c !== null);
          a.length > 0 && (s.plan = a.length === r.planDesigns.length && a.every((c) => c.wellbores.length === 0) ? [] : a);
        }
      else {
        const a = [];
        for (const c of e.plan)
          if (c.wellbores.length === 0) {
            const u = r == null ? void 0 : r.planDesigns.find((h) => h.id === c.designId), d = (o = u == null ? void 0 : u.wellbores.filter((h) => l(h.id, "plan", c.designId)).map((h) => ({ wellboreId: h.id, trajectories: [] }))) != null ? o : [];
            if (d.length === 0)
              continue;
            u && d.length === u.wellbores.length ? a.push({ designId: c.designId, wellbores: [] }) : a.push({ designId: c.designId, wellbores: d });
          } else {
            const u = c.wellbores.filter((d) => l(d.wellboreId, "plan", c.designId));
            u.length > 0 && a.push({
              designId: c.designId,
              wellbores: u.map((d) => structuredClone(d))
            });
          }
        a.length > 0 && (s.plan = a);
      }
    return s;
  }
  togglePrimaryExpanded() {
    this.primaryExpanded = !this.primaryExpanded;
  }
  toggleRootExpanded() {
    this.rootExpanded = !this.rootExpanded;
  }
  toggleWellExpanded(e) {
    this.expandedWellIds.has(e) ? this.expandedWellIds.delete(e) : this.expandedWellIds.add(e);
  }
  toggleFactExpanded(e) {
    this.expandedFactWellIds.has(e) ? this.expandedFactWellIds.delete(e) : this.expandedFactWellIds.add(e);
  }
  togglePlanExpanded(e) {
    this.expandedPlanWellIds.has(e) ? this.expandedPlanWellIds.delete(e) : this.expandedPlanWellIds.add(e);
  }
  toggleDesignExpanded(e, t) {
    const n = `${e}:design:${t}`;
    this.expandedDesignKeys.has(n) ? this.expandedDesignKeys.delete(n) : this.expandedDesignKeys.add(n);
  }
  toggleWellboreExpanded(e, t, n, r) {
    const l = t === "plan" && w(r) ? `${e}:plan:${r}:wb:${n}` : `${e}:fact:wb:${n}`;
    this.expandedWellboreKeys.has(l) ? this.expandedWellboreKeys.delete(l) : this.expandedWellboreKeys.add(l);
  }
  setAllChecked(e) {
    const t = this.service.primaryWellId, n = w(t) ? this.selectedTree.wells.find((o) => o.wellId === t) : void 0, r = n ? ue(n) : void 0;
    if (!e) {
      this.setDraftTree({ wells: r ? [r] : [] });
      return;
    }
    const l = this.visibility, s = this.catalogWells.map((o) => {
      const a = { wellId: o.id };
      return l.showFact && (a.fact = []), l.showPlan && (a.plan = []), a;
    });
    r && s.push(r), this.setDraftTree({ wells: s });
  }
  setWellChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.filter((r) => r.wellId !== e);
    if (t) {
      const r = { wellId: e }, l = this.visibility;
      l.showFact && (r.fact = []), l.showPlan && (r.plan = []), n.push(r);
    }
    this.setDraftTree({ wells: n });
  }
  setFactChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.map(ue);
    let r = n.find((l) => l.wellId === e);
    if (!r) {
      if (!t)
        return;
      r = { wellId: e }, n.push(r);
    }
    if (t)
      r.fact = [];
    else {
      delete r.fact;
      const l = this.forcedPrimarySelection;
      (l == null ? void 0 : l.wellId) === e && l.branch === "fact" && Object.assign(r, it(r, l, this.service.getWellChildren(e)));
    }
    this.commitWells(n);
  }
  setPlanChecked(e, t) {
    if (this.isPrimarySubtreeLocked(e))
      return;
    const n = this.selectedTree.wells.map(ue);
    let r = n.find((l) => l.wellId === e);
    if (!r) {
      if (!t)
        return;
      r = { wellId: e }, n.push(r);
    }
    if (t)
      r.plan = [];
    else {
      delete r.plan;
      const l = this.forcedPrimarySelection;
      (l == null ? void 0 : l.wellId) === e && l.branch === "plan" && Object.assign(r, it(r, l, this.service.getWellChildren(e)));
    }
    this.commitWells(n);
  }
  setFactWellboreChecked(e, t, n) {
    this.isPrimarySubtreeLocked(e) || !n && this.isWellboreForced(e, "fact", t) || this.updateFactWellbores(e, (r, l) => {
      const s = r.filter((o) => o.wellboreId !== t);
      return n ? (s.push({ wellboreId: t, trajectories: [] }), l && s.length === l.factWellbores.length && s.every((a) => a.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: s }) : s.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: s };
    });
  }
  setFactTrajectoryChecked(e, t, n, r) {
    this.isPrimarySubtreeLocked(e) || !r && this.isTrajectoryForced(e, "fact", t, n) || this.updateFactWellbores(e, (l, s) => {
      var m;
      const o = s == null ? void 0 : s.factWellbores.find((f) => f.id === t), a = (m = o == null ? void 0 : o.trajectories.map((f) => f.id)) != null ? m : [], c = l.find((f) => f.wellboreId === t), u = new Set(
        c ? c.trajectories.length === 0 ? a : c.trajectories.map((f) => f.trajectoryId) : []
      );
      r ? u.add(n) : u.delete(n);
      const d = l.filter((f) => f.wellboreId !== t);
      if (u.size === 0)
        return d.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: d };
      const h = a.length > 0 && u.size === a.length ? [] : Array.from(u).map((f) => ({ trajectoryId: f }));
      return d.push({ wellboreId: t, trajectories: h }), s && d.length === s.factWellbores.length && d.every((S) => S.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: d };
    });
  }
  setDesignChecked(e, t, n) {
    this.isPrimarySubtreeLocked(e) || this.updatePlanDesigns(e, (r, l) => {
      const s = r.filter((o) => o.designId !== t);
      if (!n) {
        const o = this.forcedPrimarySelection;
        return (o == null ? void 0 : o.wellId) === e && o.branch === "plan" && o.designId === t ? (s.push({
          designId: t,
          wellbores: [
            {
              wellboreId: o.wellboreId,
              trajectories: w(o.trajectoryId) ? [{ trajectoryId: o.trajectoryId }] : []
            }
          ]
        }), { kind: "partial", designs: s }) : s.length === 0 ? { kind: "none" } : { kind: "partial", designs: s };
      }
      return s.push({ designId: t, wellbores: [] }), l && s.length === l.planDesigns.length && s.every((a) => a.wellbores.length === 0) ? { kind: "whole" } : { kind: "partial", designs: s };
    });
  }
  setPlanWellboreChecked(e, t, n, r) {
    this.isPrimarySubtreeLocked(e) || !r && this.isWellboreForced(e, "plan", n, t) || this.updatePlanDesignWellbores(e, t, (l, s) => {
      const o = l.filter((a) => a.wellboreId !== n);
      return r ? (o.push({ wellboreId: n, trajectories: [] }), s && o.length === s.wellbores.length && o.every((c) => c.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: o }) : o.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: o };
    });
  }
  setPlanTrajectoryChecked(e, t, n, r, l) {
    this.isPrimarySubtreeLocked(e) || !l && this.isTrajectoryForced(e, "plan", n, r, t) || this.updatePlanDesignWellbores(e, t, (s, o) => {
      var f;
      const a = o == null ? void 0 : o.wellbores.find((S) => S.id === n), c = (f = a == null ? void 0 : a.trajectories.map((S) => S.id)) != null ? f : [], u = s.find((S) => S.wellboreId === n), d = new Set(
        u ? u.trajectories.length === 0 ? c : u.trajectories.map((S) => S.trajectoryId) : []
      );
      l ? d.add(r) : d.delete(r);
      const h = s.filter((S) => S.wellboreId !== n);
      if (d.size === 0)
        return h.length === 0 ? { kind: "none" } : { kind: "partial", wellbores: h };
      const m = c.length > 0 && d.size === c.length ? [] : Array.from(d).map((S) => ({ trajectoryId: S }));
      return h.push({ wellboreId: n, trajectories: m }), o && h.length === o.wellbores.length && h.every((W) => W.trajectories.length === 0) ? { kind: "whole" } : { kind: "partial", wellbores: h };
    });
  }
  updateFactWellbores(e, t) {
    var a;
    const n = this.selectedTree.wells.map(ue);
    let r = n.find((c) => c.wellId === e);
    const l = this.service.getWellChildren(e);
    r || (r = { wellId: e }, n.push(r));
    const s = r.fact === void 0 ? [] : r.fact.length === 0 ? (a = l == null ? void 0 : l.factWellbores.map((c) => ({ wellboreId: c.id, trajectories: [] }))) != null ? a : [] : r.fact, o = t(
      s.map((c) => structuredClone(c)),
      l
    );
    o.kind === "whole" ? r.fact = [] : o.kind === "none" ? delete r.fact : r.fact = o.wellbores, this.commitWells(n);
  }
  updatePlanDesigns(e, t) {
    var a;
    const n = this.selectedTree.wells.map(ue);
    let r = n.find((c) => c.wellId === e);
    const l = this.service.getWellChildren(e);
    r || (r = { wellId: e }, n.push(r));
    const s = r.plan === void 0 ? [] : r.plan.length === 0 ? (a = l == null ? void 0 : l.planDesigns.map((c) => ({
      designId: c.id,
      wellbores: []
    }))) != null ? a : [] : r.plan, o = t(
      s.map((c) => structuredClone(c)),
      l
    );
    o.kind === "whole" ? r.plan = [] : o.kind === "none" ? delete r.plan : r.plan = o.designs, this.commitWells(n);
  }
  updatePlanDesignWellbores(e, t, n) {
    this.updatePlanDesigns(e, (r, l) => {
      var d;
      const s = l == null ? void 0 : l.planDesigns.find((h) => h.id === t), o = r.find((h) => h.designId === t), a = o ? o.wellbores.length === 0 ? (d = s == null ? void 0 : s.wellbores.map((h) => ({ wellboreId: h.id, trajectories: [] }))) != null ? d : [] : o.wellbores : [], c = n(
        a.map((h) => structuredClone(h)),
        s
      ), u = r.filter((h) => h.designId !== t);
      return c.kind === "none" ? u.length === 0 ? { kind: "none" } : { kind: "partial", designs: u } : (c.kind === "whole" ? u.push({ designId: t, wellbores: [] }) : u.push({ designId: t, wellbores: c.wellbores }), l && u.length === l.planDesigns.length && u.every((m) => m.wellbores.length === 0) ? { kind: "whole" } : { kind: "partial", designs: u });
    });
  }
  commitWells(e) {
    const t = e.filter((n) => n.fact !== void 0 || n.plan !== void 0);
    this.setDraftTree({ wells: t });
  }
  setDraftTree(e) {
    const t = jt(
      e,
      (n) => this.service.getWellChildren(n),
      this.visibility
    );
    this._draftTree = G(t);
  }
  applyPersistedSettingsSnapshot(e) {
    this._filters = J(e.filters), this.service.setSelectedTree(e.tree), this.syncDraftFromApplied();
  }
  applyPendingPersistedSettingsIfNeeded() {
    if (!this.pendingPersistedSettings)
      return !1;
    const e = this.pendingPersistedSettings;
    return this.pendingPersistedSettings = null, this.applyPersistedSettingsSnapshot(e), !0;
  }
}
g([
  T.ref
], b.prototype, "_draftTree", 2);
g([
  T.ref
], b.prototype, "_filters", 2);
g([
  T
], b.prototype, "expandedWellIds", 2);
g([
  T
], b.prototype, "expandedFactWellIds", 2);
g([
  T
], b.prototype, "expandedPlanWellIds", 2);
g([
  T
], b.prototype, "expandedDesignKeys", 2);
g([
  T
], b.prototype, "expandedWellboreKeys", 2);
g([
  T
], b.prototype, "rootExpanded", 2);
g([
  T
], b.prototype, "primaryExpanded", 2);
g([
  T
], b.prototype, "searchValue", 2);
g([
  T.ref
], b.prototype, "pendingPersistedSettings", 2);
g([
  y.bound
], b.prototype, "setFiltersHostBridge", 1);
g([
  _
], b.prototype, "filters", 1);
g([
  _
], b.prototype, "wellsSourceAllWells", 1);
g([
  _
], b.prototype, "hasFiltersHost", 1);
g([
  _
], b.prototype, "primaryWellId", 1);
g([
  _
], b.prototype, "visibility", 1);
g([
  _
], b.prototype, "forcedPrimarySelection", 1);
g([
  y.bound
], b.prototype, "setForcedPrimarySelection", 1);
g([
  _
], b.prototype, "isLoading", 1);
g([
  _
], b.prototype, "selectedTree", 1);
g([
  _
], b.prototype, "appliedTree", 1);
g([
  _
], b.prototype, "hasPendingSelectionChanges", 1);
g([
  _
], b.prototype, "catalogWells", 1);
g([
  _
], b.prototype, "primaryWell", 1);
g([
  _
], b.prototype, "allCheckState", 1);
g([
  _
], b.prototype, "allChecked", 1);
g([
  _
], b.prototype, "allIntermediate", 1);
g([
  _
], b.prototype, "wellTreeRows", 1);
g([
  y.bound
], b.prototype, "setSearchValue", 1);
g([
  y.bound
], b.prototype, "restorePersistedSettings", 1);
g([
  y.bound
], b.prototype, "setAllWellChildren", 1);
g([
  y.bound
], b.prototype, "syncDraftFromApplied", 1);
g([
  y.bound
], b.prototype, "applyDraftSelection", 1);
g([
  y.bound
], b.prototype, "applySettingsFromGroup", 1);
g([
  y.bound
], b.prototype, "resetDraftSelection", 1);
g([
  y.bound
], b.prototype, "importFiltersFromHost", 1);
g([
  y.bound
], b.prototype, "exportFiltersToHost", 1);
g([
  y.bound
], b.prototype, "togglePrimaryExpanded", 1);
g([
  y.bound
], b.prototype, "toggleRootExpanded", 1);
g([
  y.bound
], b.prototype, "toggleWellExpanded", 1);
g([
  y.bound
], b.prototype, "toggleFactExpanded", 1);
g([
  y.bound
], b.prototype, "togglePlanExpanded", 1);
g([
  y.bound
], b.prototype, "toggleDesignExpanded", 1);
g([
  y.bound
], b.prototype, "toggleWellboreExpanded", 1);
g([
  y.bound
], b.prototype, "setAllChecked", 1);
g([
  y.bound
], b.prototype, "setWellChecked", 1);
g([
  y.bound
], b.prototype, "setFactChecked", 1);
g([
  y.bound
], b.prototype, "setPlanChecked", 1);
g([
  y.bound
], b.prototype, "setFactWellboreChecked", 1);
g([
  y.bound
], b.prototype, "setFactTrajectoryChecked", 1);
g([
  y.bound
], b.prototype, "setDesignChecked", 1);
g([
  y.bound
], b.prototype, "setPlanWellboreChecked", 1);
g([
  y.bound
], b.prototype, "setPlanTrajectoryChecked", 1);
g([
  y
], b.prototype, "setDraftTree", 1);
g([
  y.bound
], b.prototype, "applyPersistedSettingsSnapshot", 1);
g([
  y.bound
], b.prototype, "applyPendingPersistedSettingsIfNeeded", 1);
var tl = Object.defineProperty, nl = Object.getOwnPropertyDescriptor, De = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? nl(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && tl(e, t, r), r;
};
class Ee {
  constructor(e) {
    I(this, "api");
    I(this, "referenceWellsStore");
    I(this, "isLoading", !1);
    I(this, "error", null);
    this.api = e.api, this.referenceWellsStore = e.referenceWellsStore, Ie(this);
  }
  *load() {
    this.isLoading = !0, this.error = null;
    try {
      const e = yield this.api.fetchChildren();
      this.referenceWellsStore.setAllWellChildren(e);
    } catch (e) {
      console.error(e), this.error = e;
    } finally {
      this.isLoading = !1;
    }
  }
  dispose() {
    this.error = null, this.isLoading = !1;
  }
}
De([
  T
], Ee.prototype, "isLoading", 2);
De([
  T
], Ee.prototype, "error", 2);
De([
  H.bound
], Ee.prototype, "load", 1);
De([
  y.bound
], Ee.prototype, "dispose", 1);
const Wl = ["Common_WellboreType", "Common_WellboreTypeInstance"];
function Kt(i) {
  return (i != null ? i : "").toString().trim().toLowerCase();
}
function _e(i) {
  const e = typeof i == "number" ? i : Number(i);
  return Number.isFinite(e) ? e : null;
}
function il(i, e) {
  const t = /* @__PURE__ */ new Map();
  if (!(i != null && i.length) || !(e != null && e.length))
    return t;
  const n = /* @__PURE__ */ new Map();
  for (const r of i) {
    const l = _e(r.id);
    l != null && n.set(l, r);
  }
  for (const r of e) {
    const l = _e(r.data.typeId), s = _e(r.data.index), o = _e(r.id), a = r.data.name;
    if (l == null || s == null || o == null || a == null)
      continue;
    const c = n.get(l);
    if (!c)
      continue;
    const u = Kt(typeof c.data.slug == "string" ? c.data.slug : void 0);
    u && t.set(`${u}:${s}`, {
      typeId: l,
      typeInstanceId: o,
      typeInstanceName: String(a)
    });
  }
  return t;
}
function Yt(i, e) {
  const t = `${Kt(i.typeSlug)}:${i.typeIndex}`, n = e.get(t);
  return n ? {
    ...i,
    typeId: n.typeId,
    typeInstanceId: n.typeInstanceId,
    typeInstanceName: n.typeInstanceName
  } : i;
}
function rl(i, e) {
  return {
    ...i,
    wellbores: i.wellbores.map((t) => Yt(t, e))
  };
}
function ll(i, e) {
  return {
    factWellbores: i.factWellbores.map((t) => Yt(t, e)),
    planDesigns: i.planDesigns.map((t) => rl(t, e))
  };
}
function sl(i, e) {
  const t = /* @__PURE__ */ new Map();
  for (const [n, r] of i)
    t.set(n, ll(r, e));
  return t;
}
function Tl(i, e) {
  return {
    async fetchChildren() {
      const [t, n] = await Promise.all([i.fetchChildren(), e()]);
      return sl(
        t,
        il(n.types, n.instances)
      );
    }
  };
}
async function Fl({
  wellId: i,
  childrenStore: e,
  templatesStore: t
}) {
  await Promise.all([e.load(), t.loadTemplatesForWell(i)]);
}
function Cl({
  wellsService: i,
  hasAssignedGroup: e,
  onCommittedSelection: t
}) {
  return e || !i.ensureDefaultPrimaryWellboreSelection() ? !1 : (t == null || t(), !0);
}
const yt = 1, ol = 0.1;
function al(i, e) {
  const t = i.isFavorite ? yt : 0, n = e.isFavorite ? yt : 0, r = i.name.localeCompare(e.name, void 0, { sensitivity: "base" }) * ol;
  return n - t + r;
}
var cl = Object.defineProperty, dl = Object.getOwnPropertyDescriptor, C = (i, e, t, n) => {
  for (var r = n > 1 ? void 0 : n ? dl(e, t) : e, l = i.length - 1, s; l >= 0; l--)
    (s = i[l]) && (r = (n ? s(e, t, r) : s(r)) || r);
  return n && r && cl(e, t, r), r;
};
function It() {
  return crypto.randomUUID();
}
function vt(i) {
  const e = fe(i.tree);
  return {
    ...i,
    tree: Et(e.tree, e.filters)
  };
}
function St(i) {
  return i != null && i.data ? i.data.type === "public" ? {
    ...i,
    data: {
      ...i.data,
      templates: i.data.templates.map(vt)
    }
  } : i.data.type === "personal" ? {
    ...i,
    data: {
      ...i.data,
      templates: i.data.templates.map(vt)
    }
  } : i : i;
}
function Ne(i, e) {
  return {
    id: i.id,
    data: e,
    status: "ACTIVE",
    objectType: i.objectType
  };
}
class x {
  constructor(e) {
    I(this, "api");
    I(this, "wellsService");
    I(this, "getOwnerUserId");
    I(this, "getDraftTree");
    I(this, "getDraftFilters");
    I(this, "applyReferenceWellsSettings");
    I(this, "onCommittedSelection");
    I(this, "groupFavorites");
    I(this, "publicDoc", null);
    I(this, "personalDoc", null);
    I(this, "isLoading", !1);
    I(this, "isSaving", !1);
    I(this, "saveModalOpen", !1);
    I(this, "renameTarget", null);
    this.api = e.api, this.wellsService = e.wellsService, this.getOwnerUserId = e.getOwnerUserId, this.getDraftTree = e.getDraftTree, this.getDraftFilters = e.getDraftFilters, this.applyReferenceWellsSettings = e.applyReferenceWellsSettings, this.onCommittedSelection = e.onCommittedSelection, this.groupFavorites = e.groupFavorites, Ie(this);
  }
  get publicGroups() {
    var t, n;
    const e = ((n = (t = this.publicDoc) == null ? void 0 : t.data) == null ? void 0 : n.type) === "public" ? this.publicDoc.data.templates : [];
    return this.mapAndSortGroups(e, "public");
  }
  get personalGroups() {
    var t, n;
    const e = ((n = (t = this.personalDoc) == null ? void 0 : t.data) == null ? void 0 : n.type) === "personal" ? this.personalDoc.data.templates : [];
    return this.mapAndSortGroups(e, "personal");
  }
  get lastAppliedTemplateId() {
    var e, t;
    return ((t = (e = this.personalDoc) == null ? void 0 : e.data) == null ? void 0 : t.type) !== "personal" ? null : this.personalDoc.data.lastAppliedTemplateId;
  }
  get hasRestorableLastAppliedGroup() {
    var t;
    const e = this.lastAppliedTemplateId;
    return w(e) ? !!((t = this.findTemplate(e, "personal")) != null ? t : this.findTemplate(e, "public")) : !1;
  }
  get hasAnyGroups() {
    return this.publicGroups.length > 0 || this.personalGroups.length > 0;
  }
  get canCreate() {
    return w(this.wellsService.primaryWellId) && !this.isLoading;
  }
  openSaveModal() {
    this.saveModalOpen = !0;
  }
  closeSaveModal() {
    this.saveModalOpen = !1;
  }
  openRenameModal(e) {
    this.renameTarget = e;
  }
  closeRenameModal() {
    this.renameTarget = null;
  }
  toggleGroupFavorite(e) {
    var r, l, s;
    const t = this.wellsService.primaryWellId;
    if (!w(t))
      return;
    const n = (l = (r = this.groupFavorites) == null ? void 0 : r.getFavoriteGroupId(t)) != null ? l : null;
    (s = this.groupFavorites) == null || s.setFavorite(t, n === e ? null : e);
  }
  isGroupFavorite(e) {
    var n;
    const t = this.wellsService.primaryWellId;
    return w(t) ? ((n = this.groupFavorites) == null ? void 0 : n.getFavoriteGroupId(t)) === e : !1;
  }
  *loadTemplatesForWell(e) {
    var t, n;
    if (!w(e)) {
      this.publicDoc = null, this.personalDoc = null;
      return;
    }
    this.isLoading = !0;
    try {
      const r = this.getOwnerUserId(), [l, s] = yield Promise.all([this.api.listPublic(e), this.api.listPersonal(e, r)]);
      this.publicDoc = St((t = l[0]) != null ? t : null), this.personalDoc = St((n = s[0]) != null ? n : null);
    } catch (r) {
      console.error(r), this.publicDoc = null, this.personalDoc = null;
    } finally {
      this.isLoading = !1;
    }
  }
  *reloadForWellChange(e) {
    this.commitSelectedTree(Fe()), yield this.loadTemplatesForWell(e), this.restoreLastApplied(), yield this.applyFavoriteForWell(e);
  }
  *createGroupFromCurrentSelection(e, t, n = "") {
    yield this.createGroupWithTree(e, t, this.getSelectionTreeForSave(), n);
  }
  *createGroupWithTree(e, t, n, r = "") {
    const l = this.wellsService.primaryWellId;
    if (!w(l))
      return;
    const s = e.trim();
    if (s) {
      this.isSaving = !0;
      try {
        const o = r.trim(), a = {
          id: It(),
          name: s,
          ...o ? { description: o } : {},
          tree: this.wrapSelectionForSave(n)
        };
        t === "public" ? yield this.appendTemplateToPublic(l, a) : yield this.appendTemplateToPersonal(l, a), this.saveModalOpen = !1;
      } catch (o) {
        console.error(o);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *renameGroup(e, t, n, r = "") {
    const l = n.trim();
    if (l) {
      this.isSaving = !0;
      try {
        const s = r.trim();
        yield this.updateTemplateFields(e, t, (o) => {
          const a = {
            ...o,
            name: l
          };
          return s ? a.description = s : delete a.description, a;
        }), this.renameTarget = null;
      } catch (s) {
        console.error(s);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *updateGroupWithCurrentTree(e, t) {
    this.isSaving = !0;
    try {
      const n = this.wrapSelectionForSave(this.getSelectionTreeForSave());
      yield this.updateTemplateFields(e, t, (r) => ({
        ...r,
        tree: n
      })), this.saveModalOpen = !1;
    } catch (n) {
      console.error(n);
    } finally {
      this.isSaving = !1;
    }
  }
  *applyGroup(e, t) {
    const n = this.findTemplate(e, t);
    if (n) {
      this.isSaving = !0;
      try {
        this.commitGroupSettings(fe(n.tree)), yield this.setLastAppliedTemplateId(e);
      } catch (r) {
        console.error(r);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *duplicateGroup(e, t) {
    const n = this.findTemplate(e, t), r = this.wellsService.primaryWellId;
    if (!(!n || !w(r))) {
      this.isSaving = !0;
      try {
        const l = fe(n.tree), s = {
          id: It(),
          name: n.name,
          ...n.description ? { description: n.description } : {},
          tree: this.wrapSelectionForSave(l.tree)
        };
        (t === "public" ? "personal" : "public") === "public" ? yield this.appendTemplateToPublic(r, s) : yield this.appendTemplateToPersonal(r, s);
      } catch (l) {
        console.error(l);
      } finally {
        this.isSaving = !1;
      }
    }
  }
  *deleteGroup(e, t) {
    this.isSaving = !0;
    try {
      if (t === "public") {
        const s = this.publicDoc;
        if (!s || s.data.type !== "public")
          return;
        const o = s.data.templates.filter((c) => c.id !== e), a = {
          ...s.data,
          templates: o
        };
        o.length === 0 ? (yield this.api.delete(s.id), this.publicDoc = null) : (yield this.api.update(s.id, a), this.publicDoc = { ...s, data: a });
        return;
      }
      const n = this.personalDoc;
      if (!n || n.data.type !== "personal")
        return;
      const r = n.data.templates.filter((s) => s.id !== e), l = {
        ...n.data,
        templates: r,
        lastAppliedTemplateId: n.data.lastAppliedTemplateId === e ? null : n.data.lastAppliedTemplateId
      };
      r.length === 0 && !w(l.lastAppliedTemplateId) ? (yield this.api.delete(n.id), this.personalDoc = null) : (yield this.api.update(n.id, l), this.personalDoc = { ...n, data: l });
    } catch (n) {
      console.error(n);
    } finally {
      this.isSaving = !1;
    }
  }
  *applyFavoriteForWell(e) {
    var n, r;
    if (!w(e))
      return;
    const t = (r = (n = this.groupFavorites) == null ? void 0 : n.getFavoriteGroupId(e)) != null ? r : null;
    if (w(t)) {
      if (this.findTemplate(t, "personal")) {
        yield this.applyGroup(t, "personal");
        return;
      }
      this.findTemplate(t, "public") && (yield this.applyGroup(t, "public"));
    }
  }
  restoreLastApplied() {
    var n, r, l;
    if (((r = (n = this.personalDoc) == null ? void 0 : n.data) == null ? void 0 : r.type) !== "personal")
      return;
    const e = this.personalDoc.data.lastAppliedTemplateId;
    if (!w(e))
      return;
    const t = (l = this.findTemplate(e, "personal")) != null ? l : this.findTemplate(e, "public");
    t && this.commitGroupSettings(fe(t.tree));
  }
  mapAndSortGroups(e, t) {
    var l, s;
    const n = this.wellsService.primaryWellId, r = w(n) && (s = (l = this.groupFavorites) == null ? void 0 : l.getFavoriteGroupId(n)) != null ? s : null;
    return e.map((o) => ({
      id: o.id,
      name: o.name,
      description: o.description,
      visibility: t,
      isFavorite: r === o.id
    })).sort(al);
  }
  getSelectionTreeForSave() {
    var e, t;
    return (t = (e = this.getDraftTree) == null ? void 0 : e.call(this)) != null ? t : this.wellsService.selectedTree;
  }
  getFiltersForSave() {
    var e, t;
    return (t = (e = this.getDraftFilters) == null ? void 0 : e.call(this)) != null ? t : null;
  }
  wrapSelectionForSave(e) {
    return Gt(
      e,
      this.getFiltersForSave(),
      (t) => this.wellsService.getWellChildren(t),
      this.wellsService.visibility
    );
  }
  /** Apply group envelope to RW (tree + filters). Falls back to tree-only commit. */
  commitGroupSettings(e) {
    var t;
    if (this.applyReferenceWellsSettings) {
      this.applyReferenceWellsSettings(e);
      return;
    }
    this.wellsService.setSelectedTree(e.tree), (t = this.onCommittedSelection) == null || t.call(this);
  }
  commitSelectedTree(e) {
    var t;
    this.wellsService.setSelectedTree(e), (t = this.onCommittedSelection) == null || t.call(this);
  }
  findTemplate(e, t) {
    var n, r, l, s;
    if (t === "public")
      return ((r = (n = this.publicDoc) == null ? void 0 : n.data) == null ? void 0 : r.type) !== "public" ? void 0 : this.publicDoc.data.templates.find((o) => o.id === e);
    if (((s = (l = this.personalDoc) == null ? void 0 : l.data) == null ? void 0 : s.type) === "personal")
      return this.personalDoc.data.templates.find((o) => o.id === e);
  }
  async appendTemplateToPublic(e, t) {
    const n = this.publicDoc;
    if (n && n.data.type === "public") {
      const s = {
        ...n.data,
        templates: [...n.data.templates, t]
      };
      await this.api.update(n.id, s), Y(() => {
        this.publicDoc = { ...n, data: s };
      });
      return;
    }
    const r = {
      type: "public",
      wellId: e,
      templates: [t]
    }, l = await this.api.create(r);
    Y(() => {
      this.publicDoc = Ne(l, r);
    });
  }
  async appendTemplateToPersonal(e, t) {
    const n = this.personalDoc, r = this.getOwnerUserId();
    if (n && n.data.type === "personal") {
      const o = {
        ...n.data,
        templates: [...n.data.templates, t]
      };
      await this.api.update(n.id, o), Y(() => {
        this.personalDoc = { ...n, data: o };
      });
      return;
    }
    const l = {
      type: "personal",
      ownerUserId: r,
      wellId: e,
      lastAppliedTemplateId: null,
      templates: [t]
    }, s = await this.api.create(l);
    Y(() => {
      this.personalDoc = Ne(s, l);
    });
  }
  async updateTemplateFields(e, t, n) {
    if (t === "public") {
      const s = this.publicDoc;
      if (!s || s.data.type !== "public")
        return;
      const o = {
        ...s.data,
        templates: s.data.templates.map((a) => a.id === e ? n(a) : a)
      };
      await this.api.update(s.id, o), Y(() => {
        this.publicDoc = { ...s, data: o };
      });
      return;
    }
    const r = this.personalDoc;
    if (!r || r.data.type !== "personal")
      return;
    const l = {
      ...r.data,
      templates: r.data.templates.map((s) => s.id === e ? n(s) : s)
    };
    await this.api.update(r.id, l), Y(() => {
      this.personalDoc = { ...r, data: l };
    });
  }
  async setLastAppliedTemplateId(e) {
    const t = this.wellsService.primaryWellId;
    if (!w(t))
      return;
    const n = this.personalDoc, r = this.getOwnerUserId();
    if (n && n.data.type === "personal") {
      const o = {
        ...n.data,
        lastAppliedTemplateId: e
      };
      await this.api.update(n.id, o), Y(() => {
        this.personalDoc = { ...n, data: o };
      });
      return;
    }
    const l = {
      type: "personal",
      ownerUserId: r,
      wellId: t,
      lastAppliedTemplateId: e,
      templates: []
    }, s = await this.api.create(l);
    Y(() => {
      this.personalDoc = Ne(s, l);
    });
  }
}
C([
  T.ref
], x.prototype, "publicDoc", 2);
C([
  T.ref
], x.prototype, "personalDoc", 2);
C([
  T
], x.prototype, "isLoading", 2);
C([
  T
], x.prototype, "isSaving", 2);
C([
  T
], x.prototype, "saveModalOpen", 2);
C([
  T
], x.prototype, "renameTarget", 2);
C([
  _
], x.prototype, "publicGroups", 1);
C([
  _
], x.prototype, "personalGroups", 1);
C([
  _
], x.prototype, "lastAppliedTemplateId", 1);
C([
  _
], x.prototype, "hasRestorableLastAppliedGroup", 1);
C([
  _
], x.prototype, "hasAnyGroups", 1);
C([
  _
], x.prototype, "canCreate", 1);
C([
  y.bound
], x.prototype, "openSaveModal", 1);
C([
  y.bound
], x.prototype, "closeSaveModal", 1);
C([
  y.bound
], x.prototype, "openRenameModal", 1);
C([
  y.bound
], x.prototype, "closeRenameModal", 1);
C([
  y.bound
], x.prototype, "toggleGroupFavorite", 1);
C([
  H.bound
], x.prototype, "loadTemplatesForWell", 1);
C([
  H.bound
], x.prototype, "reloadForWellChange", 1);
C([
  H.bound
], x.prototype, "createGroupFromCurrentSelection", 1);
C([
  H.bound
], x.prototype, "createGroupWithTree", 1);
C([
  H.bound
], x.prototype, "renameGroup", 1);
C([
  H.bound
], x.prototype, "updateGroupWithCurrentTree", 1);
C([
  H.bound
], x.prototype, "applyGroup", 1);
C([
  H.bound
], x.prototype, "duplicateGroup", 1);
C([
  H.bound
], x.prototype, "deleteGroup", 1);
C([
  H.bound
], x.prototype, "applyFavoriteForWell", 1);
C([
  y.bound
], x.prototype, "restoreLastApplied", 1);
export {
  K as DEFAULT_REFERENCE_WELLS_VISIBILITY,
  bn as EMPTY_REFERENCE_WELLS_FILTERS,
  wl as REFERENCE_DATA_TEMPLATES_OBJECT_TYPE,
  x as ReferenceDataTemplatesStore,
  Ee as ReferenceWellsChildrenStore,
  _l as ReferenceWellsPanel,
  j as ReferenceWellsService,
  b as ReferenceWellsStore,
  Wl as WELLBORE_TYPE_DIRECTORY_OBJECTS,
  Cl as applyDefaultPrimaryWellboreIfNoGroup,
  il as buildWellboreTypeLookup,
  sl as enrichReferenceWellChildrenByWellId,
  ll as enrichReferenceWellChildrenCatalog,
  Wn as expandSelectedReferenceTreeForPersistence,
  $t as isForcedDesign,
  Ot as isForcedFactBranch,
  ze as isForcedPlanBranch,
  Ve as isForcedTrajectory,
  ye as isForcedWellbore,
  Bt as isSameForcedPrimarySelection,
  Fl as loadReferenceWellsSyncWithTemplates,
  fe as parseVersionedReferenceWellsSettings,
  Sl as parseVersionedSelectedReferenceTree,
  Tl as withWellboreTypeEnrichment,
  Gt as wrapSelectedReferenceTreeForPersistence,
  Et as wrapVersionedSelectedReferenceTree
};
//# sourceMappingURL=reference-wells.es.js.map
